/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by src/build/generate-schemas.ts
 *
 * Run 'npm run generate:schemas' to regenerate
 */

import type { BehaviorSchema } from './types';

export const GENERATED_BEHAVIOR_SCHEMAS: BehaviorSchema[] = [
  {
    "type": "AiSession",
    "description": "AiSession behavior data.\n\nInert: nothing in the runtime reads it, and nothing renders from it. It marks\na node under the editor root whose `src` is an AI conversation, a session\nfile carried as an ordinary data file, so an editor finds its conversations\nby type rather than by name or by reading every JSON file in the document.\nThe node's name is the conversation's title, and the last such node in\ndocument order is the current one.\n\nEditor documents only: a conversation never reaches a viewer, and a host\nnever puts one in a scene document.",
    "fields": []
  },
  {
    "type": "Animation",
    "description": "Controls animation playback for objects with Animation components",
    "fields": [
      {
        "key": "clip",
        "type": "string",
        "label": "Clip",
        "description": "Name of animation clip to play on start",
        "optional": true
      },
      {
        "key": "src",
        "type": "string",
        "label": "Src",
        "description": "External animation source GLB path (e.g. \"./assets/clips/walk.glb\").\nWhen set, loads the clip from this GLB and plays it on the animation root.",
        "optional": true
      },
      {
        "key": "target",
        "type": "enum",
        "label": "Target",
        "options": [
          "@self",
          "@vroot"
        ],
        "description": "Which node external clip animations target.\n- \"@self\": animate the SceneObject's own transform directly\n- \"@vroot\": animate an intermediate animation root node (keeps the\n  SceneObject's logical transform undisturbed)\n\nOnly relevant when `src` is set (external clips). Defaults to \"@vroot\"\nat runtime when omitted.",
        "optional": true
      },
      {
        "key": "clips",
        "type": "array",
        "label": "Clips",
        "itemFields": [
          {
            "key": "name",
            "type": "string",
            "label": "Name",
            "description": "Animation clip name"
          },
          {
            "key": "wrap",
            "type": "string",
            "label": "Wrap",
            "description": "Wrap mode for this clip"
          }
        ],
        "itemLabel": "Animation Clip Data",
        "description": "Array of clip override settings",
        "optional": true
      },
      {
        "key": "wrapMode",
        "type": "enum",
        "label": "Wrap Mode",
        "options": [
          "Once",
          "Loop",
          "PingPong",
          "ClampForever"
        ],
        "default": "Loop",
        "description": "Default wrap mode for animations"
      },
      {
        "key": "speed",
        "type": "number",
        "label": "Speed",
        "default": 1,
        "step": 0.1,
        "description": "Playback speed multiplier"
      },
      {
        "key": "playAutomatically",
        "type": "boolean",
        "label": "Play Automatically",
        "default": true,
        "description": "Whether to play automatically on start"
      }
    ]
  },
  {
    "type": "AnimationSequence",
    "description": "Controls animation sequences with enter/main/exit states.\nAnimations are applied to the SceneObject's animation root.",
    "fields": [
      {
        "key": "states",
        "type": "object",
        "label": "States",
        "fields": [
          {
            "key": "enter",
            "type": "object",
            "label": "Enter",
            "fields": [
              {
                "key": "src",
                "type": "string",
                "label": "Src",
                "description": "Source URL or path to the animation GLB file",
                "optional": true
              },
              {
                "key": "clip",
                "type": "string",
                "label": "Clip",
                "description": "Animation clip name\nOptional; defaults to first clip in GLB",
                "optional": true
              },
              {
                "key": "speed",
                "type": "number",
                "label": "Speed",
                "description": "Animation playback speed (defaults to 1 at runtime)",
                "optional": true
              },
              {
                "key": "delay",
                "type": "number",
                "label": "Delay",
                "description": "Delay in seconds before this clip auto-plays (defaults to 0). The\nenter clip holds posed at its first frame through the delay — the\nbuilding block for staggered entrances; the exit clip's delay offsets\norchestrated departures. The main (looping) slot does not read it.",
                "optional": true
              }
            ],
            "description": "Enter animation state (plays once when object enters)",
            "optional": true
          },
          {
            "key": "main",
            "type": "object",
            "label": "Main",
            "fields": [
              {
                "key": "src",
                "type": "string",
                "label": "Src",
                "description": "Source URL or path to the animation GLB file",
                "optional": true
              },
              {
                "key": "clip",
                "type": "string",
                "label": "Clip",
                "description": "Animation clip name\nOptional; defaults to first clip in GLB",
                "optional": true
              },
              {
                "key": "speed",
                "type": "number",
                "label": "Speed",
                "description": "Animation playback speed (defaults to 1 at runtime)",
                "optional": true
              },
              {
                "key": "delay",
                "type": "number",
                "label": "Delay",
                "description": "Delay in seconds before this clip auto-plays (defaults to 0). The\nenter clip holds posed at its first frame through the delay — the\nbuilding block for staggered entrances; the exit clip's delay offsets\norchestrated departures. The main (looping) slot does not read it.",
                "optional": true
              }
            ],
            "description": "Main animation state (loops while object is active)",
            "optional": true
          },
          {
            "key": "exit",
            "type": "object",
            "label": "Exit",
            "fields": [
              {
                "key": "src",
                "type": "string",
                "label": "Src",
                "description": "Source URL or path to the animation GLB file",
                "optional": true
              },
              {
                "key": "clip",
                "type": "string",
                "label": "Clip",
                "description": "Animation clip name\nOptional; defaults to first clip in GLB",
                "optional": true
              },
              {
                "key": "speed",
                "type": "number",
                "label": "Speed",
                "description": "Animation playback speed (defaults to 1 at runtime)",
                "optional": true
              },
              {
                "key": "delay",
                "type": "number",
                "label": "Delay",
                "description": "Delay in seconds before this clip auto-plays (defaults to 0). The\nenter clip holds posed at its first frame through the delay — the\nbuilding block for staggered entrances; the exit clip's delay offsets\norchestrated departures. The main (looping) slot does not read it.",
                "optional": true
              }
            ],
            "description": "Exit animation state (plays once when object exits)",
            "optional": true
          }
        ],
        "description": "Animation states"
      }
    ]
  },
  {
    "type": "AudioClip",
    "description": "Standalone audio clip playback. The SceneObject's `src` field carries the\nmedia URL (mp3 in v1; any format the browser's HTMLAudioElement decodes\nworks once added to AUDIO_EXTENSIONS).\n\nAudio plays through the element's default sink by default. Add an\n`AudioSource` behavior on the same SceneObject to route the audio through\nthe Web Audio graph for volume, distance attenuation, and 3D positioning.",
    "fields": [
      {
        "key": "playOnStart",
        "type": "boolean",
        "label": "Play On Start",
        "default": true,
        "description": "Whether to start playback automatically when the scene enters play mode."
      },
      {
        "key": "loop",
        "type": "boolean",
        "label": "Loop",
        "default": true,
        "description": "Whether to loop playback."
      },
      {
        "key": "startAt",
        "type": "number",
        "label": "Start At",
        "default": 0,
        "step": 0.001,
        "description": "Timeline time, in seconds, at which the clip's first sample sounds\n(after Opus pre-skip). A driving Timeline's `seek(t)` places the media\nat `t − startAt` (clamped at 0); for `t < startAt` the clip is silent\nand starts by itself when the clip's time reaches `startAt` while\nplaying. Negative means the audio began before t = 0, so t = 0 lands\n`−startAt` seconds into the media. The same offset applies without a\nTimeline: the clip's own `play()`/`playOnStart` count from t = 0."
      }
    ],
    "actions": [
      {
        "name": "play",
        "label": "Start playback"
      },
      {
        "name": "pause",
        "label": "Pause playback"
      },
      {
        "name": "stop",
        "label": "Stop and rewind to the beginning"
      },
      {
        "name": "seek",
        "label": "Seek to a time in seconds. Args: (time, mode?) where mode is \"absolute\" (default) or \"relative\"."
      },
      {
        "name": "setVolume",
        "label": "Set element volume, 0-1 (takes volume argument). For spatial control use AudioSource."
      }
    ]
  },
  {
    "type": "AudioSource",
    "description": "Spatial audio output. Pairs with a sibling Video or AudioClip behavior on\nthe same SceneObject and routes the element's audio through the Web Audio\ngraph for 3D positioning and distance-based volume.",
    "fields": [
      {
        "key": "volume",
        "type": "number",
        "label": "Volume",
        "default": 1,
        "step": 0.05,
        "min": 0,
        "max": 1,
        "description": "Master volume (0 = silent, 1 = unattenuated)"
      },
      {
        "key": "minDistance",
        "type": "number",
        "label": "Min Distance",
        "default": 1,
        "step": 0.5,
        "min": 0,
        "description": "Distance at which volume is at maximum. Inside this radius, no attenuation is applied."
      },
      {
        "key": "maxDistance",
        "type": "number",
        "label": "Max Distance",
        "default": 10,
        "step": 1,
        "min": 0,
        "description": "Distance at which volume reaches zero (Linear) or its rolloff floor (Logarithmic)."
      },
      {
        "key": "volumeRollOff",
        "type": "enum",
        "label": "Volume Roll Off",
        "options": [
          "Linear",
          "Logarithmic"
        ],
        "default": "Linear",
        "description": "How volume attenuates with distance between min and max."
      },
      {
        "key": "spatialBlend",
        "type": "number",
        "label": "Spatial Blend",
        "default": 1,
        "step": 0.05,
        "min": 0,
        "max": 1,
        "description": "Mix between 2D (non-spatialized) and 3D (positioned) audio.\n0 = pure 2D (full volume regardless of position), 1 = pure 3D (full spatial attenuation)."
      }
    ]
  },
  {
    "type": "AutoUI",
    "description": "AutoUI automatically discovers Properties and Interactions from child\nSceneObjects (including self) and renders them as an interactive UI panel.",
    "fields": [
      {
        "key": "renderMode",
        "type": "enum",
        "label": "Render Mode",
        "options": [
          "ScreenSpaceOverlay",
          "ScreenSpaceCamera",
          "WorldSpace"
        ],
        "description": "How to render the UI:\n- ScreenSpaceOverlay: Full-screen overlay (default)\n- ScreenSpaceCamera: Screen-space relative to camera\n- WorldSpace: Attached to a 3D plane in the scene",
        "optional": true
      },
      {
        "key": "propertyGroups",
        "type": "string",
        "label": "Property Groups",
        "arrayOf": "string",
        "description": "Optional: Specify a parent object by name to discover properties from.\nIf provided (with a single item), the AutoUI will traverse children of\nthat object instead of its own children. This supports backwards compatibility.\nIf not provided, discovers from this object's own children.",
        "optional": true
      },
      {
        "key": "title",
        "type": "string",
        "label": "Title",
        "description": "Panel title (optional)",
        "optional": true
      },
      {
        "key": "collapsible",
        "type": "boolean",
        "label": "Collapsible",
        "description": "Let viewers expand/collapse the panel using its title button.",
        "optional": true
      },
      {
        "key": "collapseBelowWidth",
        "type": "number",
        "label": "Collapse Below Width",
        "description": "Start collapsed below this CSS viewport width (when collapsible). 0 disables.",
        "optional": true
      },
      {
        "key": "collapseOnView",
        "type": "boolean",
        "label": "Collapse On View",
        "description": "Collapse a collapsible inspector after selecting a camera view. Default false.",
        "optional": true
      },
      {
        "key": "readout",
        "type": "string",
        "label": "Readout",
        "description": "Read-only explanatory text below the controls. Supports native bindings and newlines.",
        "format": "multiline",
        "optional": true
      },
      {
        "key": "cameraViews",
        "type": "array",
        "label": "Camera Views",
        "itemFields": [
          {
            "key": "label",
            "type": "string",
            "label": "Label"
          },
          {
            "key": "yaw",
            "type": "number",
            "label": "Yaw",
            "step": 0.01,
            "default": 0,
            "description": "Azimuth in degrees."
          },
          {
            "key": "pitch",
            "type": "number",
            "label": "Pitch",
            "step": 0.01,
            "default": 0,
            "description": "Polar angle from up, degrees (90 = level)."
          },
          {
            "key": "target",
            "type": "string",
            "label": "Target",
            "description": "SceneObject path relative to the AutoUI owner. Omit to frame the owner.\nAn unresolved explicit target leaves the camera unchanged."
          },
          {
            "key": "radiusScale",
            "type": "number",
            "label": "Radius Scale",
            "step": 0.01,
            "default": 1.1,
            "description": "Padding around the target bounds. Must be finite and >= 1."
          }
        ],
        "itemLabel": "Auto U I Camera View",
        "description": "Named orbit views of this object's contents. Yaw is azimuth in degrees;\npitch is the polar angle from up (90 = level, 0 = above).\nSelecting a view also fits the object's contents in the current viewport.",
        "optional": true
      },
      {
        "key": "width",
        "type": "number",
        "label": "Width",
        "description": "Panel width in pixels (default: 300)",
        "optional": true
      },
      {
        "key": "position",
        "type": "object",
        "label": "Position",
        "fields": [
          {
            "key": "x",
            "type": "number",
            "label": "X"
          },
          {
            "key": "y",
            "type": "number",
            "label": "Y"
          }
        ],
        "description": "Panel position for ScreenSpace modes (pixels from top-left)",
        "optional": true
      }
    ]
  },
  {
    "type": "BehaviorGraph",
    "fields": [
      {
        "key": "graph",
        "type": "object",
        "label": "Graph",
        "fields": [
          {
            "key": "types",
            "type": "array",
            "label": "Types",
            "itemFields": [
              {
                "key": "signature",
                "type": "string",
                "label": "Signature"
              }
            ],
            "itemLabel": "Type Definition",
            "default": [],
            "description": "Type definitions referenced by index"
          },
          {
            "key": "declarations",
            "type": "array",
            "label": "Declarations",
            "itemFields": [
              {
                "key": "op",
                "type": "string",
                "label": "Op",
                "description": "Namespaced operation type, e.g. \"math/add\", \"trace/setActive\""
              },
              {
                "key": "extensions",
                "type": "string",
                "label": "Extensions",
                "description": "TRACE_subgraph extension — when present, this declaration's op is\nimplemented by the referenced subgraph rather than a built-in block."
              }
            ],
            "itemLabel": "Declaration",
            "default": [],
            "description": "Node operation declarations referenced by index"
          },
          {
            "key": "variables",
            "type": "array",
            "label": "Variables",
            "itemFields": [
              {
                "key": "name",
                "type": "string",
                "label": "Name",
                "description": "Variable name (for editor UI — resolution is by index)"
              },
              {
                "key": "type",
                "type": "number",
                "label": "Type",
                "step": 0.01,
                "default": 0,
                "description": "Index into types[]"
              },
              {
                "key": "value",
                "type": "string",
                "label": "Value",
                "arrayOf": "unknown",
                "default": [],
                "description": "Initial value as flat component array"
              }
            ],
            "itemLabel": "Graph Variable",
            "default": [],
            "description": "Graph-scoped mutable variables"
          },
          {
            "key": "events",
            "type": "array",
            "label": "Events",
            "itemFields": [
              {
                "key": "id",
                "type": "string",
                "label": "Id",
                "description": "External event identifier. Empty string = an INTERNAL event (the KHR\nspec's event without an `id`): it only links `event/send` to\n`event/receive` nodes of the same graph — the way repetition (e.g. the\nInterval macro) re-enters an acyclic graph. Nodes address events by\nINDEX (`configuration.event`), never by id."
              },
              {
                "key": "values",
                "type": "string",
                "label": "Values",
                "description": "Optional typed parameters"
              }
            ],
            "itemLabel": "Graph Event",
            "default": [],
            "description": "Custom event definitions"
          },
          {
            "key": "nodes",
            "type": "array",
            "label": "Nodes",
            "itemFields": [
              {
                "key": "declaration",
                "type": "number",
                "label": "Declaration",
                "step": 0.01,
                "default": 0,
                "description": "Index into declarations[]"
              },
              {
                "key": "configuration",
                "type": "string",
                "label": "Configuration",
                "description": "Static configuration (target paths, clip names, variable indices)"
              },
              {
                "key": "values",
                "type": "string",
                "label": "Values",
                "description": "Value input sockets — data dependencies"
              },
              {
                "key": "flows",
                "type": "string",
                "label": "Flows",
                "description": "Flow output sockets — execution routing"
              },
              {
                "key": "metadata",
                "type": "string",
                "label": "Metadata",
                "description": "Editor metadata (position, etc.) — ignored by runtime"
              }
            ],
            "itemLabel": "Graph Node",
            "default": [],
            "description": "The nodes"
          },
          {
            "key": "inputFlowSockets",
            "type": "object",
            "label": "Input Flow Sockets",
            "fields": [
              {
                "key": "node",
                "type": "number",
                "label": "Node"
              },
              {
                "key": "socket",
                "type": "string",
                "label": "Socket"
              }
            ],
            "isMap": true,
            "description": "Named flow entry points — maps socket name → internal node+socket",
            "optional": true
          },
          {
            "key": "outputFlowSockets",
            "type": "object",
            "label": "Output Flow Sockets",
            "fields": [
              {
                "key": "node",
                "type": "number",
                "label": "Node"
              },
              {
                "key": "socket",
                "type": "string",
                "label": "Socket"
              }
            ],
            "isMap": true,
            "description": "Named flow exit points — maps socket name → internal node+socket",
            "optional": true
          },
          {
            "key": "inputValueSockets",
            "type": "object",
            "label": "Input Value Sockets",
            "fields": [
              {
                "key": "type",
                "type": "number",
                "label": "Type",
                "description": "Index into this graph's types[] array"
              },
              {
                "key": "node",
                "type": "number",
                "label": "Node",
                "description": "Internal node index that consumes this input (editor only)",
                "optional": true
              },
              {
                "key": "socket",
                "type": "string",
                "label": "Socket",
                "description": "Socket name on the internal node (editor only, defaults to the socket key name)",
                "optional": true
              },
              {
                "key": "description",
                "type": "string",
                "label": "Description",
                "description": "Human-readable description (editor only)",
                "optional": true
              }
            ],
            "isMap": true,
            "description": "Named value inputs with types — the parent supplies these",
            "optional": true
          },
          {
            "key": "outputValueSockets",
            "type": "object",
            "label": "Output Value Sockets",
            "fields": [
              {
                "key": "node",
                "type": "number",
                "label": "Node",
                "description": "Internal node index that produces this output"
              },
              {
                "key": "socket",
                "type": "string",
                "label": "Socket",
                "description": "Socket name on the internal node"
              },
              {
                "key": "type",
                "type": "number",
                "label": "Type",
                "description": "Index into this graph's types[] array"
              },
              {
                "key": "description",
                "type": "string",
                "label": "Description",
                "description": "Human-readable description (editor only)",
                "optional": true
              }
            ],
            "isMap": true,
            "description": "Named value outputs — points to internal node+socket that produces the value",
            "optional": true
          }
        ],
        "default": {
          "types": [],
          "declarations": [],
          "variables": [],
          "events": [],
          "nodes": []
        },
        "description": "The behavior graph definition (single-graph mode, backward compat).\nWhen `graphs` is present, this field is ignored."
      },
      {
        "key": "graphs",
        "type": "array",
        "label": "Graphs",
        "itemFields": [
          {
            "key": "types",
            "type": "string",
            "label": "Types",
            "arrayOf": "{ signature: \"string\" | \"bool\" | \"int\" | \"float\" | \"float2\" | \"float3\" | \"float4\" | \"float2x2\" | \"float3x3\" | \"float4x4\" | \"color\" }",
            "default": [],
            "description": "Type definitions referenced by index"
          },
          {
            "key": "declarations",
            "type": "string",
            "label": "Declarations",
            "arrayOf": "{ op: string; extensions?: object }",
            "default": [],
            "description": "Node operation declarations referenced by index"
          },
          {
            "key": "variables",
            "type": "string",
            "label": "Variables",
            "arrayOf": "{ name: string; type: number; value: unknown[] }",
            "default": [],
            "description": "Graph-scoped mutable variables"
          },
          {
            "key": "events",
            "type": "string",
            "label": "Events",
            "arrayOf": "{ id: string; values?: object }",
            "default": [],
            "description": "Custom event definitions"
          },
          {
            "key": "nodes",
            "type": "string",
            "label": "Nodes",
            "arrayOf": "{ declaration: number; configuration?: object; values?: object; flows?: object; metadata?: object }",
            "default": [],
            "description": "The nodes"
          },
          {
            "key": "inputFlowSockets",
            "type": "string",
            "label": "Input Flow Sockets",
            "description": "Named flow entry points — maps socket name → internal node+socket"
          },
          {
            "key": "outputFlowSockets",
            "type": "string",
            "label": "Output Flow Sockets",
            "description": "Named flow exit points — maps socket name → internal node+socket"
          },
          {
            "key": "inputValueSockets",
            "type": "string",
            "label": "Input Value Sockets",
            "description": "Named value inputs with types — the parent supplies these"
          },
          {
            "key": "outputValueSockets",
            "type": "string",
            "label": "Output Value Sockets",
            "description": "Named value outputs — points to internal node+socket that produces the value"
          }
        ],
        "itemLabel": "Graph Data",
        "description": "Multiple graph definitions (TRACE_subgraph mode).\ngraphs[0] is typically the main graph; other entries are subgraph definitions.\nThe active (entry-point) graph index is specified by `activeGraph`.",
        "optional": true
      },
      {
        "key": "activeGraph",
        "type": "number",
        "label": "Active Graph",
        "default": 0,
        "description": "Index into `graphs[]` for the entry-point graph. Defaults to 0."
      }
    ]
  },
  {
    "type": "Bevel",
    "description": "Rounds the corners of the node's primitive.\n\nA geometry modifier, not a shape: it regenerates the node's cube or\nplane primitive with its four corners filleted (the RealityKit\n`generateBox(cornerRadius:)` analog, applied Blender-modifier-style).\nCorner arcs are aspect-compensated against the node's scale, so radii\nstay circular however the slab is stretched. Flat hosts (planes) stay\nflat; slabs keep their thickness.\n\n`cornerRadius` is in METERS, the unit the solver hands out and the same\none MeshBackground, Image and Video use (#759). CSS-pixel semantics: a\nresized slab keeps its corner SIZE rather than its corner proportion.\n`pill` asks for half the current smaller side instead — \"a capsule,\nwhatever size the solver picks\" — which is the one thing an absolute\nradius cannot say. The radius clamps to half the smaller side at render,\nso an oversized value degrades to a pill rather than self-crossing.\n\nStrictly geometry: paint stays on Renderer, sizing stays on the\ntransform. Clients without a Bevel implementation render the sharp\nprimitive — content intact, corners square.",
    "fields": [
      {
        "key": "cornerRadius",
        "type": "number",
        "label": "Corner Radius",
        "default": 0,
        "step": 0.001,
        "min": 0,
        "description": "Corner radius in meters. Clamped to half the smaller side at render."
      },
      {
        "key": "pill",
        "type": "boolean",
        "label": "Pill",
        "default": false,
        "description": "Round the corners to half the current smaller side — a capsule at any\nsize. Overrides `cornerRadius` when true."
      },
      {
        "key": "axis",
        "type": "enum",
        "label": "Axis",
        "options": [
          "auto",
          "x",
          "y",
          "z"
        ],
        "default": "auto",
        "description": "Extrusion axis — corners are rounded in the perpendicular plane.\n\"auto\" picks the slab's thinnest world axis (its natural thickness);\nflat hosts (planes) always round in their own plane."
      },
      {
        "key": "edges",
        "type": "enum",
        "label": "Edges",
        "options": [
          "corners",
          "all"
        ],
        "default": "corners",
        "description": "Which edges to round. \"corners\" fillets the four side edges only;\n\"all\" also rounds the rim where the walls meet the faces (a fully\nfilleted box — rim radius is the corner radius clamped to half the\nthickness, so thin slabs get a soft pill edge). Ignored on flat hosts."
      }
    ]
  },
  {
    "type": "Billboard",
    "description": "Makes an object always face the camera",
    "fields": [
      {
        "key": "enabled",
        "type": "boolean",
        "label": "Enabled",
        "default": true,
        "description": "Whether facing is active when play mode starts. When false the object\nsits at its authored rotation until the behavior graph enables it\n(trace/setBehaviorEnabled). Disabling at runtime applies `onExit`\n(ease back or hold); every play-mode start resets to this value."
      },
      {
        "key": "axes",
        "type": "multiSelect",
        "label": "Axes",
        "options": [
          "x",
          "y",
          "z"
        ],
        "default": [
          "x",
          "y",
          "z"
        ],
        "description": "Rotation axes that track the camera. \"y\" enables turning (yaw),\n\"x\" enables tilting (pitch); \"z\" (banking) must be ignored by\nimplementations. Omitted = all axes (the classic full billboard)."
      },
      {
        "key": "influence",
        "type": "number",
        "label": "Influence",
        "default": 1,
        "description": "How completely the object turns toward the camera, 0-1.\n1 faces dead-on; lower values make a partial, more lifelike turn."
      },
      {
        "key": "damping",
        "type": "number",
        "label": "Damping",
        "default": 0,
        "description": "Turning lag as a time constant in seconds — larger trails the camera\nmore softly. 0 snaps instantly (the classic billboard)."
      },
      {
        "key": "viewAngle",
        "type": "number",
        "label": "View Angle",
        "default": 0,
        "description": "Engagement cone half-angle in degrees, measured from the authored\nresting direction: the object tracks the camera only while the camera\nsits within `viewAngle` degrees of the rest forward (full cone apex\nangle = 2 × viewAngle). Outside it, tracking disengages and `onExit`\napplies. 0 = unlimited (always track); values >= 180 also mean\nunlimited (the cone covers everything). Same name and unit as\nViewAnchor's `viewAngle`."
      },
      {
        "key": "onExit",
        "type": "enum",
        "label": "On Exit",
        "options": [
          "return",
          "hold"
        ],
        "default": "return",
        "description": "What happens when the camera leaves the view cone: ease back to the\nauthored rotation (\"return\") or keep the last orientation (\"hold\")."
      },
      {
        "key": "reverse",
        "type": "boolean",
        "label": "Reverse",
        "default": false,
        "description": "When true, the object faces away from the camera instead of toward it."
      },
      {
        "key": "minDistance",
        "type": "number",
        "label": "Min Distance",
        "default": 0,
        "description": "Minimum distance from the camera at which the billboard effect is active.\nBelow this distance the billboard orientation is frozen."
      }
    ]
  },
  {
    "type": "BoxCollider",
    "description": "Box-shaped collider for physics and interaction detection",
    "fields": [
      {
        "key": "size",
        "type": "vec3",
        "label": "Size",
        "description": "Size of the box collider in local space.\nWhen omitted, derived from model bounding box if present, else from the\nselection box of a meshless object such as Text (at least 5 cm deep), otherwise 1x1x1.",
        "optional": true
      },
      {
        "key": "center",
        "type": "vec3",
        "label": "Center",
        "description": "Center offset of the collider relative to the transform.\nWhen omitted, derived from the center of that bounding box if present, otherwise origin.",
        "optional": true
      }
    ]
  },
  {
    "type": "ContentSlot",
    "description": "Fits the container's single child to the container's width and height.\n\nOnly width and height constrain the fit; depth never does. The container's\ndepth should Hug, so it follows the fitted content and the stack around it\nre-solves. The content root must Hug (or be Fixed) on its own axes — its\nscale-1 box is what the fit divides the slot by.",
    "fields": [
      {
        "key": "fit",
        "type": "enum",
        "label": "Fit",
        "options": [
          "contain",
          "scale-down",
          "none"
        ],
        "default": "contain",
        "description": "How the content meets the slot."
      },
      {
        "key": "zooms",
        "type": "string",
        "label": "Zooms",
        "arrayOf": "number",
        "description": "Discrete scale steps. The fit takes the largest step that fits both\nwidth and height (and, under `scale-down`, is at most 1); when none\ndoes, it takes the continuous ratio. Absent or empty means continuous.",
        "optional": true
      }
    ]
  },
  {
    "type": "Frame",
    "description": "Adds a customizable frame around images or other content",
    "fields": [
      {
        "key": "borderWidth",
        "type": "number",
        "label": "Border Width",
        "default": 3,
        "step": 1,
        "description": "Width of frame border in pixels"
      },
      {
        "key": "color",
        "type": "color",
        "label": "Color",
        "default": "#FFD700",
        "description": "Frame color in hex format\nExamples: \"#FFD700\", \"#FF0000AA\""
      },
      {
        "key": "src",
        "type": "string",
        "label": "Src",
        "description": "Path to custom frame GLB model\nWhen provided, uses custom 3D frame instead of generated frame",
        "optional": true
      }
    ]
  },
  {
    "type": "Image",
    "description": "Controls image display settings",
    "fields": [
      {
        "key": "aspect",
        "type": "number",
        "label": "Aspect",
        "step": 0.01,
        "description": "Image aspect ratio (width/height).\n\nAbsent means UNKNOWN, not square. It used to default to 1, so every\nimage node was born claiming to be square — a claim made before anything\nhad looked at the image, yet strong enough to letterbox a landscape node\ndown to a square plane when the texture never arrived. Matches Video,\nwhere the field has always been optional and undefined means \"nobody has\nmeasured this yet\".",
        "optional": true
      },
      {
        "key": "orientation",
        "type": "enum",
        "label": "Orientation",
        "options": [
          "Horizontal",
          "Vertical"
        ],
        "default": "Vertical",
        "description": "Image orientation"
      },
      {
        "key": "fit",
        "type": "enum",
        "label": "Fit",
        "options": [
          "contain",
          "cover"
        ],
        "default": "contain",
        "description": "How the image meets a box whose aspect differs from its own.\n\n`contain` (the default) letterboxes: the plane shrinks on one axis so\nthe whole image stays visible inside the box, never distorted.\n\n`cover` fills: the plane spans the box exactly and a centered window\nof the image is shown instead, cropping the overflowing axis. The\ncrop is a view, not an edit — switching back to `contain` shows the\nfull image again.\n\nAbsent means `contain`: exactly the fit scenes have always had."
      },
      {
        "key": "cornerRadius",
        "type": "number",
        "label": "Corner Radius",
        "default": 0,
        "step": 0.001,
        "min": 0,
        "description": "Corner radius in meters (the unit MeshBackground's cornerRadius\nuses; measured here on the CURRENT visible media rectangle - a\nmedia quad has no rest box). One value gives differently sized\nframes identical corners, and a resized frame keeps its corner\nsize. Never larger than half the rectangle's current smaller side\n- an oversized value degrades to a pill instead of self-crossing.\n\nRounds the media quad itself, which neither Bevel (its host gate\ntakes only builtin primitives) nor MeshBackground (drives the\nlibrary rigs' authored morphs) can reach. Composes with `fit`: the\ncorners round the letterboxed rectangle under `contain`, the full\nbox under `cover`. Strictly geometry: paint stays on Renderer,\nsizing stays on the transform; clients without a corner-radius\nimplementation render the sharp rectangle - content intact."
      },
      {
        "key": "pill",
        "type": "boolean",
        "label": "Pill",
        "default": false,
        "description": "Round the quad to half its smaller side — a capsule at any size,\nwhich is the one shape an absolute radius cannot name. Overrides\n`cornerRadius` when true. Same vocabulary as Bevel and\nMeshBackground (#759)."
      },
      {
        "key": "back",
        "type": "enum",
        "label": "Back",
        "options": [
          "none",
          "picture",
          "color"
        ],
        "default": "none",
        "description": "What the quad's back shows. `none` culls it: nothing is drawn behind\nthe picture. `picture` renders the media on both faces of the one\nquad - seen from behind it reads mirrored, as a print does through\nits paper (a two-sided quad; glTF's doubleSided idea, NOT a second\nreadable surface). `color` backs the picture with a flat unlit\n`backColor` card that also shows through transparent pixels from the\nfront. A GLB export carries what the object shows: `picture` as the\ndoubled quad, `color` as a second mesh named `<quad>_back`."
      },
      {
        "key": "backColor",
        "type": "color",
        "label": "Back Color",
        "default": "#FFFFFF",
        "description": "The card color behind the picture when `back` is `color`\n(#RRGGBB or #RRGGBBAA - the alpha rides the string). Ignored for\nthe other values."
      }
    ]
  },
  {
    "type": "ImageAnchor",
    "description": "Describes an image-marker anchor for a scene.\n\nAttached to the scene root in editor mode as a UI affordance: it renders a\npreview of the printed marker (textured plane at physical scale) and lets\nthe author edit the marker's expected orientation. Source-of-truth for the\nmarker URL and physical width currently lives on the CMS Scene record;\nthis behavior is CMS-managed and is excluded from `.trace` export. It\nround-trips through the publish-metadata channel.",
    "fields": [
      {
        "key": "src",
        "type": "string",
        "label": "Src",
        "description": "URL of the marker image asset.",
        "optional": true
      },
      {
        "key": "widthMeters",
        "type": "number",
        "label": "Width Meters",
        "default": 0.2,
        "step": 0.01,
        "description": "Physical width of the printed marker in meters."
      },
      {
        "key": "orientation",
        "type": "enum",
        "label": "Orientation",
        "options": [
          "Horizontal",
          "Vertical",
          "Free"
        ],
        "default": "Free",
        "description": "Expected marker orientation in the world.\n`Free` means the runtime accepts any detected pose."
      },
      {
        "key": "pitchDegrees",
        "type": "number",
        "label": "Pitch Degrees",
        "default": 0,
        "step": 1,
        "description": "Pitch of the marker in degrees, about the marker's local X axis\n(image-right). Positive values tilt the marker's top edge away\nfrom the viewer.\n\n`orientation` and `pitchDegrees` describe the same pose at\ndifferent fidelities — `pitchDegrees` is the full angle, while\n`orientation` is a semantic label (Wall / Floor / Free). When\n`orientation` is `Vertical` or `Horizontal` it gives the complete\npose and `pitchDegrees` is ignored. When `orientation` is `Free`\nor unset, `pitchDegrees` provides the absolute angle."
      }
    ]
  },
  {
    "type": "Keyframes",
    "description": "Keyframes behavior — named subtree configurations with transitions.\n\nAttach to a container object. Each keyframe describes what its subtree\nshould look like when active. The runtime pushes each entry as a state\ncontribution onto the target descendant's `Properties` resolver — the\nresolver then handles interpolation, cascade, active toggling, and\n`enterFrom` snap.\n\nTarget paths must have a `Properties` behavior attached to receive\ncontributions; entries on bare nodes are skipped with a warning.",
    "fields": [
      {
        "key": "keyframes",
        "type": "object",
        "label": "Keyframes",
        "fields": [
          {
            "key": "transition",
            "type": "object",
            "label": "Transition",
            "fields": [
              {
                "key": "duration",
                "type": "number",
                "label": "Duration",
                "min": 0,
                "description": "Transition duration in seconds"
              },
              {
                "key": "easing",
                "type": "enum",
                "label": "Easing",
                "options": [
                  "linear",
                  "easeIn",
                  "easeOut",
                  "easeInOut",
                  "snap",
                  "back",
                  "anticipate"
                ],
                "default": "easeInOut",
                "description": "Easing function"
              },
              {
                "key": "delay",
                "type": "number",
                "label": "Delay",
                "default": 0,
                "min": 0,
                "description": "Delay before transition starts, in seconds"
              }
            ],
            "default": {
              "duration": 0.5,
              "easing": "easeInOut"
            },
            "description": "Default transition when navigating TO this keyframe.\nPer-entry transitions override this."
          },
          {
            "key": "entries",
            "type": "object",
            "label": "Entries",
            "fields": [
              {
                "key": "transform",
                "type": "object",
                "label": "Transform",
                "fields": [
                  {
                    "key": "position",
                    "type": "vec3",
                    "label": "Position",
                    "description": "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                    "optional": true
                  },
                  {
                    "key": "rotation",
                    "type": "vec4",
                    "label": "Rotation",
                    "description": "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                    "optional": true
                  },
                  {
                    "key": "scale",
                    "type": "vec3",
                    "label": "Scale",
                    "description": "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                    "optional": true
                  }
                ],
                "description": "Absolute local pose for this keyframe. Same semantics as\n`StateDefinition.transform` — replaces per component, omit → authored.",
                "optional": true
              },
              {
                "key": "values",
                "type": "object",
                "label": "Values",
                "fields": [],
                "isMap": true,
                "description": "Property value overrides. Keyed by property name.\nValues are PropertyValue: string | number | boolean | [n,n,n] | [n,n,n,n].\nOmitted properties keep their resolved value.",
                "optional": true
              },
              {
                "key": "active",
                "type": "boolean",
                "label": "Active",
                "description": "Visibility override. Omitted means no change from authored base.",
                "optional": true
              },
              {
                "key": "transition",
                "type": "object",
                "label": "Transition",
                "fields": [
                  {
                    "key": "duration",
                    "type": "number",
                    "label": "Duration",
                    "min": 0,
                    "description": "Transition duration in seconds"
                  },
                  {
                    "key": "easing",
                    "type": "enum",
                    "label": "Easing",
                    "options": [
                      "linear",
                      "easeIn",
                      "easeOut",
                      "easeInOut",
                      "snap",
                      "back",
                      "anticipate"
                    ],
                    "default": "easeInOut",
                    "description": "Easing function"
                  },
                  {
                    "key": "delay",
                    "type": "number",
                    "label": "Delay",
                    "default": 0,
                    "min": 0,
                    "description": "Delay before transition starts, in seconds"
                  }
                ],
                "description": "Per-entry transition override for stagger / per-child timing.\nIf omitted, uses the keyframe-level transition, then the behavior-level default.",
                "optional": true
              },
              {
                "key": "enterFrom",
                "type": "object",
                "label": "Enter From",
                "fields": [
                  {
                    "key": "position",
                    "type": "vec3",
                    "label": "Position",
                    "description": "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                    "optional": true
                  },
                  {
                    "key": "rotation",
                    "type": "vec4",
                    "label": "Rotation",
                    "description": "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                    "optional": true
                  },
                  {
                    "key": "scale",
                    "type": "vec3",
                    "label": "Scale",
                    "description": "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                    "optional": true
                  }
                ],
                "description": "Entry pose for objects becoming active (`active:false → true`). The runtime\nsnaps to this absolute local pose (omitted fields fall back to the keyframe\npose) and animates to the keyframe pose. Same absolute semantics as `transform`.",
                "optional": true
              }
            ],
            "isMap": true,
            "description": "Sparse object overrides, keyed by TransformPath relative to the container.\n\n`\"./\"` targets the container itself (for inherited property values).\n`\"./Page1/Car\"` targets a descendant.\n\nObjects not listed keep their authored configuration.\nObjects listed in the previous keyframe but not this one revert to authored base."
          }
        ],
        "isMap": true,
        "description": "Named keyframes. Keys are keyframe names."
      },
      {
        "key": "initialKeyframe",
        "type": "string",
        "label": "Initial Keyframe",
        "description": "The initially active keyframe (by name).\nIf omitted, the scene starts at authored base (no keyframe active).",
        "optional": true
      },
      {
        "key": "transitionDuration",
        "type": "number",
        "label": "Transition Duration",
        "default": 0.5,
        "min": 0,
        "description": "Default transition duration when a keyframe doesn't specify one."
      },
      {
        "key": "transitionEasing",
        "type": "enum",
        "label": "Transition Easing",
        "options": [
          "linear",
          "easeIn",
          "easeOut",
          "easeInOut",
          "snap",
          "back",
          "anticipate"
        ],
        "default": "easeInOut",
        "description": "Default transition easing when a keyframe doesn't specify one."
      }
    ],
    "actions": [
      {
        "name": "goTo",
        "label": "Navigate to a named keyframe"
      },
      {
        "name": "next",
        "label": "Next keyframe"
      },
      {
        "name": "prev",
        "label": "Previous keyframe"
      }
    ]
  },
  {
    "type": "Layout",
    "description": "3D flexbox auto-layout container. Children flow along the `direction` axis\n(the main axis), like a flexbox row/column extended into 3D. All lengths\nare meters.\n\nMental model — CSS/Figma mapping:\n- `direction` ≈ flex-direction (X = row, Y = column top-down, Z = depth stack running\n  away from the camera: the first child sits on the front face, each later one behind it)\n- `alignMain` ≈ justify-content, `alignCross` ≈ align-items\n- Sizing modes per axis: Fixed = explicit size, Hug ≈ fit-content, Fill ≈ flex: 1\n\nA Layout node is both a container for its children and an item in its\nparent's layout — item fields (sizing, flex, position) are inherited from\nLayoutItemInput.\n\nHow children participate:\n- Child with Layout or LayoutItem: fully managed — layout writes its\n  position, and (for leaves) its scale from the resolved size.\n- Plain child (neither behavior): positioned but never resized; its current\n  scale magnitude is read as a Fixed size. Consequence: a model moves into\n  place but keeps its own scale.\n- `positionMode: \"Absolute\"`: removed from flow — keeps its own transform\n  position; Fill/percent sizing still resolves against this container.\n\nCross-axis note: `alignCross` controls the first cross axis (e.g. X for a\nY-column); the second cross axis (depth) defaults to Center and is\nauthorable via `alignCrossB`. A single child overrides either for itself\nwith `alignSelfCross`/`alignSelfCrossB` (CSS `align-self`); unset inherits\nand keeps following the container, which repeating the container's value\ndoes not. Layout solves from\nthe topmost ancestor with a Layout behavior and recurses through plain\ngrouping nodes. Results are applied asynchronously (microtask) after commit.",
    "fields": [
      {
        "key": "direction",
        "type": "enum",
        "label": "Direction",
        "options": [
          "X",
          "Y",
          "Z"
        ],
        "default": "Y",
        "description": "Main axis direction for child flow.\nX = horizontal row, Y = vertical column, Z = depth stack, front to back\n(the first child is nearest the camera; `alignMain: \"Start\"` and `padding.front`\nname the camera-facing face).",
        "group": "Container"
      },
      {
        "key": "gap",
        "type": "number",
        "label": "Gap",
        "default": 0.02,
        "step": 0.01,
        "min": 0,
        "description": "Space between children in meters.",
        "group": "Container"
      },
      {
        "key": "padding",
        "type": "number",
        "label": "Padding",
        "objectFields": [
          {
            "key": "left",
            "type": "number",
            "label": "Left",
            "default": 0,
            "step": 0.01,
            "min": 0
          },
          {
            "key": "right",
            "type": "number",
            "label": "Right",
            "default": 0,
            "step": 0.01,
            "min": 0
          },
          {
            "key": "top",
            "type": "number",
            "label": "Top",
            "default": 0,
            "step": 0.01,
            "min": 0
          },
          {
            "key": "bottom",
            "type": "number",
            "label": "Bottom",
            "default": 0,
            "step": 0.01,
            "min": 0
          },
          {
            "key": "front",
            "type": "number",
            "label": "Front",
            "default": 0,
            "step": 0.01,
            "min": 0
          },
          {
            "key": "back",
            "type": "number",
            "label": "Back",
            "default": 0,
            "step": 0.01,
            "min": 0
          }
        ],
        "default": 0.02,
        "step": 0.01,
        "min": 0,
        "description": "Internal padding in meters. Number for uniform (all six sides), object\nfor per-side (left/right/top/bottom/front/back — omitted sides are 0).",
        "group": "Container"
      },
      {
        "key": "alignMain",
        "type": "enum",
        "label": "Align Main",
        "options": [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        "default": "Start",
        "description": "How children are distributed along the main axis.",
        "group": "Container"
      },
      {
        "key": "alignCross",
        "type": "enum",
        "label": "Align Cross",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "default": "Start",
        "description": "How children are aligned on the first cross axis (the second cross\naxis is controlled by `alignCrossB`). Stretch expands non-Fixed\nchildren to fill it.",
        "group": "Container"
      },
      {
        "key": "alignCrossB",
        "type": "enum",
        "label": "Align Cross B",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "default": "Center",
        "description": "How children are aligned on the SECOND cross axis — depth for X/Y\ndirection containers (Figma's Front/Center/Back). Stretch expands\nnon-Fixed children to fill it.",
        "group": "Container"
      },
      {
        "key": "crossGap",
        "type": "number",
        "label": "Cross Gap",
        "step": 0.01,
        "min": 0,
        "description": "Spacing in meters between wrapped lines/layers on the cross axes.\nFalls back to `gap` when absent.",
        "group": "Container",
        "optional": true
      },
      {
        "key": "wrap",
        "type": "boolean",
        "label": "Wrap",
        "default": false,
        "description": "Wrap children to the next line when they overflow the main axis.\nWhen false, children shrink per flexShrink and may overflow.",
        "group": "Container"
      },
      {
        "key": "wrapAxis",
        "type": "enum",
        "label": "Wrap Axis",
        "options": [
          "X",
          "Y",
          "Z"
        ],
        "description": "Which axis wrapped lines stack along — one of the two cross axes.\nOnly meaningful when `wrap` is true. Cross-axis ROLES follow it:\n`alignCross`, `alignContent`, and `crossGap` apply along the chosen\naxis, `alignCrossB`/`alignContentCrossB` along the other — the same\nrole re-mapping `direction` already performs. Must differ from\n`direction`; absent or invalid falls back to the implicit first\ncross axis, so existing scenes are unchanged.",
        "group": "Container",
        "optional": true
      },
      {
        "key": "alignContent",
        "type": "enum",
        "label": "Align Content",
        "options": [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        "default": "Start",
        "description": "How wrapped LINES are distributed along the first cross axis — the\nwrap counterpart of `alignMain` (CSS align-content). Ignored unless\n`wrap` is true.",
        "group": "Container"
      },
      {
        "key": "alignContentCrossB",
        "type": "enum",
        "label": "Align Content Cross B",
        "options": [
          "Start",
          "Center",
          "End",
          "SpaceBetween",
          "SpaceAround",
          "SpaceEvenly"
        ],
        "default": "Start",
        "description": "How wrapped LAYERS are distributed along the second cross axis when\nlines overflow into it. Ignored unless `wrap` is true.",
        "group": "Container"
      },
      {
        "key": "width",
        "type": "number",
        "label": "Width",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit width in meters.",
        "group": "Sizing"
      },
      {
        "key": "height",
        "type": "number",
        "label": "Height",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit height in meters.",
        "group": "Sizing"
      },
      {
        "key": "depth",
        "type": "number",
        "label": "Depth",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit depth in meters.",
        "group": "Sizing"
      },
      {
        "key": "widthMode",
        "type": "enum",
        "label": "Width Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How width is determined.\nFixed = use explicit width, Hug = shrink to content, Fill = expand to parent.",
        "group": "Sizing"
      },
      {
        "key": "heightMode",
        "type": "enum",
        "label": "Height Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How height is determined.",
        "group": "Sizing"
      },
      {
        "key": "depthMode",
        "type": "enum",
        "label": "Depth Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How depth is determined.",
        "group": "Sizing"
      },
      {
        "key": "minWidth",
        "type": "number",
        "label": "Min Width",
        "step": 0.01,
        "min": 0,
        "description": "Minimum width in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxWidth",
        "type": "number",
        "label": "Max Width",
        "step": 0.01,
        "min": 0,
        "description": "Maximum width in meters — a size ceiling, including wrapping for Hug Text.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "minHeight",
        "type": "number",
        "label": "Min Height",
        "step": 0.01,
        "min": 0,
        "description": "Minimum height in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxHeight",
        "type": "number",
        "label": "Max Height",
        "step": 0.01,
        "min": 0,
        "description": "Maximum height in meters — a ceiling for Fill/grow resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "minDepth",
        "type": "number",
        "label": "Min Depth",
        "step": 0.01,
        "min": 0,
        "description": "Minimum depth in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxDepth",
        "type": "number",
        "label": "Max Depth",
        "step": 0.01,
        "min": 0,
        "description": "Maximum depth in meters — a ceiling for Fill/grow resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "flexGrow",
        "type": "number",
        "label": "Flex Grow",
        "default": 0,
        "step": 0.1,
        "min": 0,
        "description": "Growth weight along the main axis when the container has free space.\n0 = auto: Fill children grow with weight 1, Fixed/Hug children don't.\nSet > 0 to weight growth among siblings (like CSS flex-grow).",
        "group": "Flex"
      },
      {
        "key": "flexShrink",
        "type": "number",
        "label": "Flex Shrink",
        "default": 1,
        "step": 0.1,
        "min": 0,
        "description": "Flex shrink factor.",
        "group": "Flex"
      },
      {
        "key": "positionMode",
        "type": "enum",
        "label": "Position Mode",
        "options": [
          "Auto",
          "Absolute"
        ],
        "default": "Auto",
        "description": "Position mode. Auto = arranged by the layout flow.\nAbsolute = removed from flow: the object keeps its own transform\nposition, but Fill/percent sizing still resolves against the parent.",
        "group": "Position"
      },
      {
        "key": "inset",
        "type": "object",
        "label": "Inset",
        "fields": [
          {
            "key": "left",
            "type": "number",
            "label": "Left",
            "step": 0.01,
            "min": 0,
            "description": "Distance from the containing box's left edge to the child's left edge.",
            "optional": true
          },
          {
            "key": "top",
            "type": "number",
            "label": "Top",
            "step": 0.01,
            "min": 0,
            "description": "Distance from the containing box's top edge to the child's top edge.",
            "optional": true
          }
        ],
        "description": "Top-left offset for an Absolute child, in meters, from the containing\nbox's corner to this child's own corner — CSS `left`/`top`. Read only\nwhen `positionMode` is Absolute; ignored on a flow child, which takes\nits position from the flow.\n\nIt exists because a corner is the only placement an author can state\nahead of the solve. The transform an Absolute child otherwise keeps is\nCENTRE-based, and converting corner to centre needs the containing size\nAND the child's own size — neither of which exists until layout runs,\nso anything upstream that converts early has to guess both and is wrong\nby half the difference whenever either extent is Hug or Fill. The\nsolver holds both numbers at the moment it places the child.",
        "group": "Position",
        "optional": true
      },
      {
        "key": "alignSelfCross",
        "type": "enum",
        "label": "Align Self Cross",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "description": "This item's own alignment on the container's FIRST cross axis,\noverriding the container's `alignCross` for this child alone — CSS\n`align-self`. Stretch fills the cross extent.\n\nUnset inherits from the container, which is not the same statement as\nsetting the container's value explicitly: an inherited value follows the\ncontainer when it changes, an authored one does not.",
        "group": "Alignment",
        "optional": true
      },
      {
        "key": "alignSelfCrossB",
        "type": "enum",
        "label": "Align Self Cross B",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "description": "This item's own alignment on the container's SECOND cross axis,\noverriding `alignCrossB` for this child alone. In a vertical container\nthat is the depth axis, which is how a single card sits proud of the\nstack it flows in.\n\nUnset inherits from the container.",
        "group": "Alignment",
        "optional": true
      }
    ]
  },
  {
    "type": "LayoutItem",
    "description": "Layout item sizing behavior — THE box authority for a node, in a Layout\ncontainer or standing alone.\n\nInside a container it is the child's sizing input, and edits re-solve the\nnearest Layout above (a LayoutItem under a plain grouping node is read at\nlayout time and now re-solves through that same ancestor walk).\n\nWith no Layout anywhere above, a Fixed width still applies: it is fed to\nany width-accepting provider on the node, so standalone text wraps to it\n(tv#709). `Hug`/`Fill` give no standalone constraint — there is no solver\nto resolve a share against — and a standalone Fixed HEIGHT does nothing to\ntext, which owns its measured height.\n\nSizing and placement fields (width/height/depth + modes, flexGrow/flexShrink, positionMode)\nare inherited from LayoutItemInput. Sizes are meters. Hug on a leaf only\nmeasures content for behaviors that provide it (e.g. Text), or opted-in\nrendered geometry; otherwise it falls back to the explicit size.",
    "fields": [
      {
        "key": "measureGeometry",
        "type": "boolean",
        "label": "Measure Geometry",
        "default": false,
        "description": "Measure rendered subtree geometry for Hug sizing on a node without Layout.\nEmpty geometry keeps the normal sizing fallback; containers and size\nreceivers retain their authority.",
        "group": "Sizing"
      },
      {
        "key": "width",
        "type": "number",
        "label": "Width",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit width in meters.",
        "group": "Sizing"
      },
      {
        "key": "height",
        "type": "number",
        "label": "Height",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit height in meters.",
        "group": "Sizing"
      },
      {
        "key": "depth",
        "type": "number",
        "label": "Depth",
        "default": 1,
        "step": 0.01,
        "min": 0,
        "description": "Explicit depth in meters.",
        "group": "Sizing"
      },
      {
        "key": "widthMode",
        "type": "enum",
        "label": "Width Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How width is determined.\nFixed = use explicit width, Hug = shrink to content, Fill = expand to parent.",
        "group": "Sizing"
      },
      {
        "key": "heightMode",
        "type": "enum",
        "label": "Height Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How height is determined.",
        "group": "Sizing"
      },
      {
        "key": "depthMode",
        "type": "enum",
        "label": "Depth Mode",
        "options": [
          "Fixed",
          "Hug",
          "Fill"
        ],
        "default": "Fixed",
        "description": "How depth is determined.",
        "group": "Sizing"
      },
      {
        "key": "minWidth",
        "type": "number",
        "label": "Min Width",
        "step": 0.01,
        "min": 0,
        "description": "Minimum width in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxWidth",
        "type": "number",
        "label": "Max Width",
        "step": 0.01,
        "min": 0,
        "description": "Maximum width in meters — a size ceiling, including wrapping for Hug Text.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "minHeight",
        "type": "number",
        "label": "Min Height",
        "step": 0.01,
        "min": 0,
        "description": "Minimum height in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxHeight",
        "type": "number",
        "label": "Max Height",
        "step": 0.01,
        "min": 0,
        "description": "Maximum height in meters — a ceiling for Fill/grow resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "minDepth",
        "type": "number",
        "label": "Min Depth",
        "step": 0.01,
        "min": 0,
        "description": "Minimum depth in meters — a floor for Fill/shrink resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "maxDepth",
        "type": "number",
        "label": "Max Depth",
        "step": 0.01,
        "min": 0,
        "description": "Maximum depth in meters — a ceiling for Fill/grow resolution.\nAbsent means unconstrained.",
        "group": "Sizing",
        "optional": true
      },
      {
        "key": "flexGrow",
        "type": "number",
        "label": "Flex Grow",
        "default": 0,
        "step": 0.1,
        "min": 0,
        "description": "Growth weight along the main axis when the container has free space.\n0 = auto: Fill children grow with weight 1, Fixed/Hug children don't.\nSet > 0 to weight growth among siblings (like CSS flex-grow).",
        "group": "Flex"
      },
      {
        "key": "flexShrink",
        "type": "number",
        "label": "Flex Shrink",
        "default": 1,
        "step": 0.1,
        "min": 0,
        "description": "Flex shrink factor.",
        "group": "Flex"
      },
      {
        "key": "positionMode",
        "type": "enum",
        "label": "Position Mode",
        "options": [
          "Auto",
          "Absolute"
        ],
        "default": "Auto",
        "description": "Position mode. Auto = arranged by the layout flow.\nAbsolute = removed from flow: the object keeps its own transform\nposition, but Fill/percent sizing still resolves against the parent.",
        "group": "Position"
      },
      {
        "key": "inset",
        "type": "object",
        "label": "Inset",
        "fields": [
          {
            "key": "left",
            "type": "number",
            "label": "Left",
            "step": 0.01,
            "min": 0,
            "description": "Distance from the containing box's left edge to the child's left edge.",
            "optional": true
          },
          {
            "key": "top",
            "type": "number",
            "label": "Top",
            "step": 0.01,
            "min": 0,
            "description": "Distance from the containing box's top edge to the child's top edge.",
            "optional": true
          }
        ],
        "description": "Top-left offset for an Absolute child, in meters, from the containing\nbox's corner to this child's own corner — CSS `left`/`top`. Read only\nwhen `positionMode` is Absolute; ignored on a flow child, which takes\nits position from the flow.\n\nIt exists because a corner is the only placement an author can state\nahead of the solve. The transform an Absolute child otherwise keeps is\nCENTRE-based, and converting corner to centre needs the containing size\nAND the child's own size — neither of which exists until layout runs,\nso anything upstream that converts early has to guess both and is wrong\nby half the difference whenever either extent is Hug or Fill. The\nsolver holds both numbers at the moment it places the child.",
        "group": "Position",
        "optional": true
      },
      {
        "key": "alignSelfCross",
        "type": "enum",
        "label": "Align Self Cross",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "description": "This item's own alignment on the container's FIRST cross axis,\noverriding the container's `alignCross` for this child alone — CSS\n`align-self`. Stretch fills the cross extent.\n\nUnset inherits from the container, which is not the same statement as\nsetting the container's value explicitly: an inherited value follows the\ncontainer when it changes, an authored one does not.",
        "group": "Alignment",
        "optional": true
      },
      {
        "key": "alignSelfCrossB",
        "type": "enum",
        "label": "Align Self Cross B",
        "options": [
          "Start",
          "Center",
          "End",
          "Stretch"
        ],
        "description": "This item's own alignment on the container's SECOND cross axis,\noverriding `alignCrossB` for this child alone. In a vertical container\nthat is the depth axis, which is how a single card sits proud of the\nstack it flows in.\n\nUnset inherits from the container.",
        "group": "Alignment",
        "optional": true
      }
    ]
  },
  {
    "type": "MarkerSlot",
    "description": "Marks an empty node as a spot where an image marker could sit. Editors use\nit to line a room up with a scene's image marker, or a marker with a room.\nThe node's name is its label.\n\nThe node's local frame is the marker frame `L` of ZIP_FRAME_CONTRACT.md:\n`+X` image-right, `+Y` image-top, `+Z` out of the face. A wall slot has `+Z`\npointing into the room; a table slot has `+Z` up. Lining up is pose\nequality between this node and the marker. The frame convention of the\nreference documents that carry slots is in TraceBackend's\n`EntityType.Reference` doc comment\n(`TraceCms/src/TraceCms.Domain/Enums/EntityType.cs`).\n\nIt has no fields and no runtime effect. Unlike `ContentSlot`, it never fits\nor scales anything. It is not localization data: it names no marker and\nlocalizes nothing (LOCALIZERS.md). The marker's width belongs to the\nscene's marker configuration, not to the slot.",
    "fields": []
  },
  {
    "type": "MeshBackground",
    "description": "MeshBackground — drives the corner-radius morphs of a rounded-background\nasset (the design library's `plane_rounded` / `cube_rounded` rigs), so one\nmesh covers sharp rectangle → rounded rectangle → pill/circle.\n\nGeometry only — fill and stroke colours belong to Renderer (the assets\nexpose them as ordinary material slots). Sizing belongs to MorphStretch:\nthe stretch morphs translate the corner arcs rigidly, so the radius is\ninvariant under resize and the two behaviors compose without coordination.\n\nHow this differs from Bevel: Bevel regenerates a builtin primitive's\ngeometry (asset-free, arbitrary radius, baked on export) — prefer it for a\nplain rounded slab. MeshBackground exists for the authored library rigs,\nwhose separate stroke-ring geometry and design-set material slots Bevel\ncannot produce.",
    "fields": [
      {
        "key": "cornerRadius",
        "type": "number",
        "label": "Corner Radius",
        "default": 0,
        "step": 0.001,
        "min": 0,
        "description": "Corner radius in meters, measured on the asset's rest box (CSS-pixel\nsemantics: an 8 mm radius stays 8 mm at any stretched size). The\nauthored morphs reach half the rest box's smaller side; a larger\nrequest saturates there. Never larger than half the *current* smaller\nside — a shrunken background keeps a valid rounded rect."
      },
      {
        "key": "pill",
        "type": "boolean",
        "label": "Pill",
        "default": false,
        "description": "Fully round: radius = half the current smaller side (pill, or circle\nwhen square). Overrides `cornerRadius`."
      }
    ]
  },
  {
    "type": "Model",
    "description": "Controls 3D model loading and display",
    "fields": [
      {
        "key": "fit",
        "type": "enum",
        "label": "Fit",
        "options": [
          "fill",
          "contain",
          "scale-down",
          "cover",
          "none"
        ],
        "default": "none",
        "description": "How the model meets a layout slot whose proportions differ from its\nown — `object-fit` for a mesh, in the same vocabulary Image and Video\nuse for a media quad.\n\n`none` (the default) is what every model has always done: the node's\nscale is the author's sizing handle, layout measures the geometry\nthrough it and never writes it. A model dropped into a slot keeps its\nreal-world size, which is the only sane default for a piece of set\ndressing placed in metres.\n\n`contain` hands the scale to layout: the model is scaled uniformly,\nas large as fits inside the slot, never distorted. This is what a\ntemplate means when it ships its own geometry for a hole it authored\n— a phone body drawn into a card-sized box.\n\n`scale-down` is `contain` that never enlarges: a model larger than\nits slot shrinks to fit, one that already fits keeps its size.\n\n`fill` scales per axis to the slot, distorting. A mesh with sculpted\ncorners or internal parts smears under it; `MorphStretch` is the\nright tool where the asset authors stretch morphs.\n\n`cover` would need to clip against the slot, which the engine cannot\ndo for a mesh, so it is accepted and clamped to `contain` with a\nwarning rather than silently overflowing.\n\nOnly slot-determined axes constrain the fit: an axis the container\nHugs was sized BY this model, and a flat depth axis is the 2D-canvas\nconvention rather than an instruction to squash the geometry."
      },
      {
        "key": "fitAnchor",
        "type": "enum",
        "label": "Fit Anchor",
        "options": [
          "center",
          "bottom"
        ],
        "default": "center",
        "description": "Where a FITTED model sits inside its slot on the vertical axis.\n\n`center` (the default) places the geometry's bounds centre at the\nslot centre — a hero floating in a card. `bottom` seats the bounds\non the slot's floor, which is what a slot standing on a plinth or a\nbench means: a low, wide model (a car) contain-fits by its width and\nwould otherwise hover a hand's width above the surface it was placed\non. Read only under a fitting `fit`; `none` keeps the author's\ntransform whole."
      }
    ]
  },
  {
    "type": "MorphStretch",
    "description": "Sizes a component mesh to a target box by driving its authored stretch\nmorph targets (`Xp_In`/`Xn_Out`/`Y_Out`… — the design-set convention),\nso borders and corners keep their sculpted proportions where plain node\nscaling would smear them. Axes without morphs fall back to direct mesh\nscaling; axes left undefined keep the authored extent. `fit` chooses how\nthe box is realized: per-axis stretch (default) or an aspect-preserving\nuniform contain fit.",
    "fields": [
      {
        "key": "width",
        "type": "number",
        "label": "Width",
        "step": 0.01,
        "description": "Target width (local X), meters",
        "optional": true
      },
      {
        "key": "height",
        "type": "number",
        "label": "Height",
        "step": 0.01,
        "description": "Target height (local Y), meters",
        "optional": true
      },
      {
        "key": "depth",
        "type": "number",
        "label": "Depth",
        "step": 0.01,
        "description": "Target depth (local Z), meters",
        "optional": true
      },
      {
        "key": "fit",
        "type": "enum",
        "label": "Fit",
        "options": [
          "fill",
          "contain"
        ],
        "default": "fill",
        "description": "How the target box is realized.\n\n`fill` (the default) drives each axis independently — morphs where\nthe asset authors them, mesh scale where it doesn't — so the geometry\nmeets the box exactly on every sized axis. `stretch` is the pre-#760\nspelling of `fill`: accepted on the wire and rewritten to `fill` on\nload and on commit, because TraceFrontend persisted it into scenes.\n\n`contain` never distorts: one uniform factor — the minimum of\ndesired/rest over the sized axes — scales all three axes, and every\nstretch morph stays at zero. The geometry keeps its authored\nproportions and fits inside the box, meeting it exactly only on the\nlimiting axis. This is the mode for solid decorative pieces (doodads)\nhanded a box authored for another component's aspect. Axes without a\nsize don't constrain the fit."
      },
      {
        "key": "innerWidth",
        "type": "number",
        "label": "Inner Width",
        "step": 0.01,
        "description": "Authored inner reference width (local X) at rest, meters — the part of\nthe asset that should meet the target box. What the measured rest\nwidth has beyond it is decorative overhang (trim, moulding, a lip),\nheld constant in absolute meters at any size: the realized outer\nwidth becomes `width + (rest − innerWidth)`. Kit convention authors\nsmart types to a 1.0 m inner reference, CENTRED ON THE OBJECT'S PIVOT\n— so layout places the pivot at the box centre and the overhang stays\non the side the artist put it (a base's lip rises above its box rather\nthan being split across both ends). Per-axis: an axis without an inner\nvalue sizes to the box exactly. Ignored by `fit: 'contain'`.",
        "optional": true
      },
      {
        "key": "innerHeight",
        "type": "number",
        "label": "Inner Height",
        "step": 0.01,
        "description": "Authored inner reference height (local Y) at rest, meters. See\n`innerWidth` — same overhang-preserving rule, on the Y axis.",
        "optional": true
      },
      {
        "key": "innerDepth",
        "type": "number",
        "label": "Inner Depth",
        "step": 0.01,
        "description": "Authored inner reference depth (local Z) at rest, meters. See\n`innerWidth` — same overhang-preserving rule, on the Z axis.",
        "optional": true
      },
      {
        "key": "weight",
        "type": "number",
        "label": "Weight",
        "default": 1,
        "step": 0.05,
        "description": "The prototype's frame weight (`weightDesignUnits / 24`): a uniform\npre-scale on the meshes. The box is fed to the geometry at `1/weight`\nand the meshes are scaled back by `weight`, so the box is still met\nexactly while the overhang thins with it — the realized outer is\n`box + weight × (rest − inner)`. A kit frame around a template slot\ncarries 0.5 (weight 12); a wrapper's own frame whatever its recipe\nsays. Ignored by `fit: 'contain'`.\n\nA converter-authored kit fact, not an editorial dial — it comes from\nthe frame's own design data, the same way `innerWidth`/etc. do. Hand\nauthoring it on a GLB whose morph targets don't match just thins an\noverhang that isn't there. Slated to move onto the kit GLB as a glTF\n`extras` field, next to the morph targets themselves (#707) — this\nscene-level copy is the interim home."
      },
      {
        "key": "range",
        "type": "vec2",
        "label": "Range",
        "description": "The prototype's proxy range, as multiples of the inner reference: the\nmorphs realize an inner within `[min, max] × inner` and the remainder\nis plain mesh scale on that axis — an axis without the needed morphs\ntakes the scale alone. This is how a kit fin asked for 0.36 m renders\nat 0.72 m (its 1.0 m rest × 0.36/0.5) and a 0.28 m base at 0.37 m\n(0.5 m plus its 0.16 m lip, × 0.56). Kit components carry `[0.5, 3]`;\nabsent, the morph range alone bounds the reach. Needs an inner\nreference on the axis; ignored by `fit: 'contain'`.\n\nA converter-authored kit fact, same footing as `weight` above — it\ndescribes what THIS asset's morph targets can actually reach, not a\nstylistic choice. Same interim-home/follow-up as `weight` (#707).",
        "optional": true
      }
    ]
  },
  {
    "type": "Moveable",
    "description": "Marks an object as moveable by dragging",
    "fields": [
      {
        "key": "axes",
        "type": "multiSelect",
        "label": "Axes",
        "options": [
          "x",
          "y",
          "z"
        ],
        "description": "Allowed movement axes. When omitted, all axes are allowed.",
        "optional": true
      },
      {
        "key": "momentumDamping",
        "type": "number",
        "label": "Momentum Damping",
        "default": 0,
        "min": 0,
        "description": "Release momentum (\"flick it and let go\"): after a drag ends, the slide\nkeeps going and eases out with this time constant in seconds — the speed\ndecays to ~37% per interval, and the total extra travel is release-speed\n× this value. 0 or absent = stops dead on release (classic behavior).\nSame seconds vocabulary as Billboard/Tether damping. Cross-platform\ncontract: docs-internal/MANIPULATION_MOMENTUM_SPEC.md."
      }
    ]
  },
  {
    "type": "Pages",
    "description": "Pages container — each direct child SceneObject is one page, except the\nchildren listed in `shared`. Only the active page is visible; shared\nchildren stay visible on every page.\n\nHierarchy:\n```\nPresentation (Pages behavior, shared: [\"./Model\"])\n  ├── Model           ← shared child: on every page, posed per page\n  │   ├── Step 1         by `pages[].states`\n  │   └── Step 2\n  ├── Page 1          ← page 0 (visible by default)\n  │   └── Caption\n  └── Page 2          ← page 1 (hidden: authored `active: false`)\n      └── Caption\n```\n\nContent of one page lives under that page's child. Content seen on\nseveral pages (a model built up step by step, a nav bar) is a shared\nchild, and each page sets its look with `pages[].states`.\n\nPages does NOT auto-hide children on load. Non-first pages must\nbe created with `active: false` so they start hidden. Entering play\nmode applies the showing page's `pages[].states`.\n\nNavigation: use the `next` / `prev` / `showPage` actions, or BehaviorGraph\npagesNext / pagesPrev blocks. Active page index is 0-based.",
    "fields": [
      {
        "key": "pages",
        "type": "array",
        "label": "Pages",
        "itemFields": [
          {
            "key": "states",
            "type": "string",
            "label": "States",
            "arrayOf": "{ target: string; state: string }",
            "description": "State assignments applied when this page is shown: each target's\nProperties behavior gets `setState(state)`. Objects assigned on any\npage but not on the shown page revert to base (`setState(undefined)`).\nOne assignment per target — later duplicates override earlier ones."
          }
        ],
        "itemLabel": "Page Data",
        "description": "Per-page transition configuration, positionally aligned with the page\nchildren (`pages[i]` configures page i). Entries may be empty (`{}`) for\npages with no state assignments; a missing/short array means the remaining\npages have none.\n\nExample — a hero that exits on page 1, and a shared `Model` whose\n`Step 2` group (with a `future` state that sets `active: false`) is\nhidden on page 0 and back at base on page 1:\n```json\n[\n  { \"states\": [{ \"target\": \"./Page1/Hero\", \"state\": \"entered\" },\n               { \"target\": \"./Model/Step 2\", \"state\": \"future\" }] },\n  { \"states\": [{ \"target\": \"./Page1/Hero\", \"state\": \"exitLeft\" }] }\n]\n```",
        "optional": true
      },
      {
        "key": "transition",
        "type": "object",
        "label": "Transition",
        "fields": [
          {
            "key": "duration",
            "type": "number",
            "label": "Duration",
            "min": 0,
            "description": "Transition duration in seconds"
          },
          {
            "key": "easing",
            "type": "enum",
            "label": "Easing",
            "options": [
              "linear",
              "easeIn",
              "easeOut",
              "easeInOut",
              "snap",
              "back",
              "anticipate"
            ],
            "default": "easeInOut",
            "description": "Easing function"
          },
          {
            "key": "delay",
            "type": "number",
            "label": "Delay",
            "default": 0,
            "min": 0,
            "description": "Delay before transition starts, in seconds"
          }
        ],
        "description": "Default transition for page state changes, applied to any child state\nthat doesn't define its own transition.\nDefaults to 0.5s easeInOut when omitted.",
        "optional": true
      },
      {
        "key": "transitionOrder",
        "type": "enum",
        "label": "Transition Order",
        "options": [
          "concurrent",
          "exitFirst"
        ],
        "default": "concurrent",
        "description": "Ordering of outgoing vs incoming motion on an animated page change —\none axis, two choreographies (room for more, e.g. an enter-first\n\"cover\" mode):\n\n- `\"concurrent\"` (default): today's overlap — the swap is immediate;\n  the outgoing page's departure motion runs while the incoming page\n  appears (crossfade model).\n- `\"exitFirst\"`: the change sequences — every AnimationSequence exit\n  clip across the outgoing page's subtree (per-slot `delay` honored,\n  nested decks excluded — they own their pages) plays to completion\n  while the incoming page stays hidden; the swap then runs as if the\n  change had begun at that moment, and the autoplay dwell re-anchors\n  there. A newer page change cancels a pending swap (last-intent\n  wins); re-requesting the SAME target fast-forwards the swap without\n  restarting the cascade; returning to the current page repairs the\n  in-flight departures. Instant (non-animated) changes bypass\n  entirely. With no exit clips on the outgoing page the swap is\n  immediate — byte-for-byte the `\"concurrent\"` behavior."
      },
      {
        "key": "advanceOnTap",
        "type": "boolean",
        "label": "Advance On Tap",
        "default": false,
        "description": "Advance to the next page when the user taps this deck's content in\nplay mode — page children and shared children alike. A tap that\nsomething acts on fires that instead and never advances: a behavior\ngraph's onSelect listening on the tapped object or an ancestor,\nruntime selection (Moveable, Rotatable, a `:selected` state), a\nscript, or a tap-to-play video. A collider or `:hover`/`:active`\nstates only make content tappable — such a tap still advances. Taps\non empty space never advance. Wrap follows `loop`\n(off = hold on the last page, on = wrap to the first)."
      },
      {
        "key": "autoplay",
        "type": "boolean",
        "label": "Autoplay",
        "default": false,
        "description": "Automatically advance pages in play mode"
      },
      {
        "key": "loop",
        "type": "boolean",
        "label": "Loop",
        "default": false,
        "description": "End-of-deck behavior: wrap from the last page back to the first.\nDeck-level, not autoplay-only — it governs autoplay advancement AND\n`advanceOnTap` wrapping alike."
      },
      {
        "key": "pageDuration",
        "type": "number",
        "label": "Page Duration",
        "default": 5,
        "description": "Duration each page is shown, in seconds. Drives autoplay advancement and\nthe Playable/Timeline mapping (seek, total duration) — it is the page's\ntimeline length, not autoplay-only config."
      },
      {
        "key": "pageSource",
        "type": "enum",
        "label": "Page Source",
        "options": [
          "self",
          "firstChild"
        ],
        "default": "self",
        "description": "Which node's children are the pages: `self` — the container's direct\nSceneObject children (default); `firstChild` — children of the\ncontainer's first child TransformNode (e.g. a GLB root)."
      },
      {
        "key": "shared",
        "type": "string",
        "label": "Shared",
        "arrayOf": "string",
        "description": "Shared children: paths (relative to the container) of direct children\nthat are NOT pages. A shared child is excluded from the page set — it\npersists across page switches, is never activated/deactivated by page\nnavigation, and is animated per page via ordinary `pages[].states`\nassignments targeting it. An unresolvable path excludes nothing (the\nchild stays a page). Only meaningful for `pageSource: \"self\"`; ignored\nin `firstChild` mode.",
        "optional": true
      }
    ],
    "actions": [
      {
        "name": "next",
        "label": "Next page"
      },
      {
        "name": "prev",
        "label": "Previous page"
      },
      {
        "name": "showPage",
        "label": "Go to a page. Args: (index, animate?) — index is 0-based, animate defaults to false"
      },
      {
        "name": "showAllPages",
        "label": "Show all pages"
      }
    ]
  },
  {
    "type": "ParticleSystem",
    "description": "Simplified particle system data.\nAll particles operate in world space (independent after spawn).",
    "fields": [
      {
        "key": "emissionRate",
        "type": "number",
        "label": "Emission Rate",
        "default": 50,
        "description": "Particles emitted per second"
      },
      {
        "key": "maxParticles",
        "type": "number",
        "label": "Max Particles",
        "default": 1000,
        "description": "Maximum particles alive at once (performance cap)"
      },
      {
        "key": "lifetime",
        "type": "object",
        "label": "Lifetime",
        "fields": [
          {
            "key": "min",
            "type": "number",
            "label": "Min"
          },
          {
            "key": "max",
            "type": "number",
            "label": "Max"
          }
        ],
        "default": {
          "min": 1,
          "max": 2
        },
        "description": "Particle lifetime range in seconds"
      },
      {
        "key": "startColor",
        "type": "color",
        "label": "Start Color",
        "default": "#FFCC00FF",
        "description": "Starting color (#RRGGBBAA hex)"
      },
      {
        "key": "startColor2",
        "type": "color",
        "label": "Start Color2",
        "description": "Optional second color for random range between startColor and startColor2",
        "optional": true
      },
      {
        "key": "endColor",
        "type": "color",
        "label": "End Color",
        "description": "Color particles fade to at end of life (#RRGGBBAA hex).\n\"#00000000\" = fade to fully transparent (alpha 00).\n\"#000000FF\" = fade to opaque black. \"#FF0000FF\" = fade to red.\nWith premultiplied blending, RGB channels have no effect when alpha is 0.",
        "optional": true
      },
      {
        "key": "startSpeed",
        "type": "object",
        "label": "Start Speed",
        "fields": [
          {
            "key": "min",
            "type": "number",
            "label": "Min"
          },
          {
            "key": "max",
            "type": "number",
            "label": "Max"
          }
        ],
        "default": {
          "min": 2,
          "max": 4
        },
        "description": "Starting speed range (world units/second)"
      },
      {
        "key": "gravityModifier",
        "type": "number",
        "label": "Gravity Modifier",
        "default": 0.3,
        "description": "Gravity multiplier (-1 = normal gravity down, 0 = no gravity, 1 = reverse)"
      },
      {
        "key": "shape",
        "type": "object",
        "label": "Shape",
        "fields": [
          {
            "key": "type",
            "type": "enum",
            "label": "Type",
            "options": [
              "Cone",
              "Sphere",
              "Box"
            ]
          },
          {
            "key": "radius",
            "type": "number",
            "label": "Radius",
            "description": "Radius for Cone and Sphere shapes (world units)",
            "optional": true
          },
          {
            "key": "angle",
            "type": "number",
            "label": "Angle",
            "description": "Angle for Cone shape (degrees, 0-90)",
            "optional": true
          },
          {
            "key": "boxSize",
            "type": "vec3",
            "label": "Box Size",
            "description": "Box dimensions [x, y, z] for Box shape (world units)",
            "optional": true
          },
          {
            "key": "emitDirection",
            "type": "vec3",
            "label": "Emit Direction",
            "description": "Emission direction for Box shape as a unit vector [x, y, z].\nDefaults to [0, 1, 0] (local Y). Unity Rectangle emits along [0, 0, 1] (local Z).",
            "optional": true
          }
        ],
        "default": {
          "type": "Cone",
          "radius": 0.05,
          "angle": 30
        },
        "description": "Emission shape configuration"
      },
      {
        "key": "texture",
        "type": "asset",
        "label": "Texture",
        "default": "",
        "description": "Particle texture asset path (local or URL). ALWAYS premultiplied RGBA — the editor\nbakes the source to premultiplied on import (see ParticleTextureMode). Runtimes load\nthis directly and blend with premultiplied Porter-Duff; they never convert it.",
        "assetType": "image"
      },
      {
        "key": "particleScale",
        "type": "number",
        "label": "Particle Scale",
        "description": "Overall particle size multiplier applied on top of sizeOverLifetime keyframes.\nDistinct from the object's transform scale which also affects emission shape.",
        "optional": true
      },
      {
        "key": "sizeOverLifetime",
        "type": "array",
        "label": "Size Over Lifetime",
        "itemFields": [
          {
            "key": "time",
            "type": "number",
            "label": "Time",
            "step": 0.01,
            "default": 0
          },
          {
            "key": "value",
            "type": "number",
            "label": "Value",
            "step": 0.01,
            "default": 0
          }
        ],
        "itemLabel": "Keyframe",
        "description": "Size multiplier over lifetime (array of keyframes, time 0-1).\nOmit for constant size.",
        "optional": true
      },
      {
        "key": "startRotation",
        "type": "object",
        "label": "Start Rotation",
        "fields": [
          {
            "key": "min",
            "type": "number",
            "label": "Min"
          },
          {
            "key": "max",
            "type": "number",
            "label": "Max"
          }
        ],
        "description": "Starting rotation range (degrees)",
        "optional": true
      },
      {
        "key": "angularVelocity",
        "type": "object",
        "label": "Angular Velocity",
        "fields": [
          {
            "key": "min",
            "type": "number",
            "label": "Min"
          },
          {
            "key": "max",
            "type": "number",
            "label": "Max"
          }
        ],
        "description": "Angular velocity range (degrees/second)",
        "optional": true
      },
      {
        "key": "noise",
        "type": "object",
        "label": "Noise",
        "fields": [
          {
            "key": "strength",
            "type": "vec3",
            "label": "Strength",
            "description": "Strength of turbulence on each axis (world units). Equal XYZ = uniform."
          },
          {
            "key": "frequency",
            "type": "number",
            "label": "Frequency",
            "description": "Noise evolution speed — higher = more chaotic, lower = smoother swirls. Default 0.5",
            "optional": true
          },
          {
            "key": "octaves",
            "type": "number",
            "label": "Octaves",
            "description": "Number of noise octaves (1-4). More = finer detail. Default 2",
            "optional": true
          },
          {
            "key": "drag",
            "type": "number",
            "label": "Drag",
            "description": "Velocity damping per second (0-1). Controls how quickly noise-induced\nvelocity decays. 0 = no damping (force accumulates), 1 = full damping\n(position-offset behavior, like Unity). Default 0.",
            "optional": true
          }
        ],
        "description": "Noise-based turbulence applied to particle velocity.\nOmit or set strength to 0 to disable.",
        "optional": true
      }
    ]
  },
  {
    "type": "Properties",
    "description": "Properties — the public interface of a template or scene object.\n\nDeclares named, typed properties with initial values, optional external sheets,\nand named states for conditional overrides with transitions. A declaration can\nalso carry `variants` (named preset values, shown as a swatch row in editors)\nand a default `transition` that animates programmatic value changes.\n\n## Binding syntax\n\nOther behaviors reference properties using `{name}` in their data fields:\n```json\n{ \"@type\": \"Renderer\", \"materials\": [{ \"baseColorFactor\": \"{color}\" }] }\n```\n\nExpressions are supported inside `{}`:\n```json\n{ \"@type\": \"Text\", \"text\": \"Distance: {floor(camera.distance)} meters\" }\n```\n\n## Complete example\n\n```json\n{\n  \"@type\": \"Properties\",\n  \"properties\": [\n    { \"name\": \"color\", \"type\": \"color\", \"value\": \"#FF0000\", \"label\": \"Primary\",\n      \"variants\": [ { \"name\": \"Red\", \"value\": \"#FF0000\" }, { \"name\": \"Teal\", \"value\": \"#00AA88\" } ],\n      \"transition\": { \"duration\": 0.3, \"easing\": \"easeOut\" } },\n    { \"name\": \"fontSize\", \"type\": \"number\", \"value\": 16, \"min\": 8, \"max\": 48 }\n  ],\n  \"states\": {\n    \":hover\": {\n      \"values\": { \"color\": \"#00FF00\" },\n      \"transition\": { \"duration\": 0.3, \"easing\": \"easeOut\" }\n    },\n    \"nearby\": {\n      \"values\": { \"color\": \"#0000FF\", \"fontSize\": 24 },\n      \"transition\": { \"driver\": \"camera.distance\", \"range\": [5, 1] }\n    }\n  },\n  \"initialState\": \"nearby\"\n}\n```",
    "fields": [
      {
        "key": "properties",
        "type": "array",
        "label": "Properties",
        "default": [],
        "description": "Property declarations — name, type, value, and optional constraints.\n\nEach property is available to descendant behaviors via `{name}` bindings.\nThe `value` is the default when no state is active and no ancestor\noverrides the property."
      },
      {
        "key": "transform",
        "type": "object",
        "label": "Transform",
        "fields": [
          {
            "key": "position",
            "type": "vec3",
            "label": "Position",
            "description": "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
            "optional": true
          },
          {
            "key": "rotation",
            "type": "vec4",
            "label": "Rotation",
            "description": "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
            "optional": true
          },
          {
            "key": "scale",
            "type": "vec3",
            "label": "Scale",
            "description": "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
            "optional": true
          }
        ],
        "description": "The object's own pose at the **base** level — no state involved.\n\nSame absolute-per-component semantics as a state's\nTransformOverride: an omitted field keeps the authored value.\nThe difference is when it applies — a state's transform applies while\nthat state is active, this one applies whenever no state overrides it,\nand it is the baseline a state reverts to.\n\nIts reason to exist is bound components: `[1, \"{stageHeight}\", 1]` makes\nthe pose a function of a declared property, re-applied whenever that\nvalue changes. Without it a property can only drive fields on behaviors,\nnever the transform of the object carrying them.\n\n```json\n{ \"@type\": \"Properties\", \"properties\": [], \"transform\": { \"scale\": [1, \"{stageHeight}\", 1] } }\n```",
        "optional": true
      },
      {
        "key": "sheets",
        "type": "string",
        "label": "Sheets",
        "arrayOf": "string",
        "description": "External property sheet URLs. Each URL points to a JSON file — either a\nbare `PropertyDeclaration[]` (v0) or a PropertySheet envelope.\nDeclarations from sheets are merged with inline `properties` — inline\ndeclarations override sheet declarations at the same name.\n\nOrder is meaningful: among sheets, the **first** to declare a name supplies\nit.\n\n**This is also how a style is applied.** A style asset *is* a sheet, so\napplying one is storing its URL here and swapping styles is replacing that\nentry — the applied style is the stored reference, with nothing inferred\nfrom values. By editor convention the entry at index 0 is the style slot\n(highest sheet precedence); further entries are ordinary declaration\nsheets or layered partial styles. See `docs/STYLES.md`.",
        "optional": true
      },
      {
        "key": "states",
        "type": "object",
        "label": "States",
        "fields": [
          {
            "key": "values",
            "type": "object",
            "label": "Values",
            "fields": [],
            "isMap": true,
            "description": "Property value overrides. Keys are property names from declarations.\nValues must match the property's declared type.\nProperties not listed keep their value (or ancestor override)."
          },
          {
            "key": "transform",
            "type": "object",
            "label": "Transform",
            "fields": [
              {
                "key": "position",
                "type": "vec3",
                "label": "Position",
                "description": "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                "optional": true
              },
              {
                "key": "rotation",
                "type": "vec4",
                "label": "Rotation",
                "description": "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                "optional": true
              },
              {
                "key": "scale",
                "type": "vec3",
                "label": "Scale",
                "description": "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                "optional": true
              }
            ],
            "description": "Transform overrides applied to the owning SceneObject when the state is active.\nInterpolated alongside property values during transitions.",
            "optional": true
          },
          {
            "key": "active",
            "type": "boolean",
            "label": "Active",
            "description": "Active (enabled) override. When the top eligible state declares\n`active: false`, the owning object is hidden after the state's transition\ncompletes. `active: true` shows it immediately so the object is visible\nduring entry animation. Runtime only: the object's authored `active` is\nunchanged. Omitted means no change.",
            "optional": true
          },
          {
            "key": "enterFrom",
            "type": "object",
            "label": "Enter From",
            "fields": [
              {
                "key": "position",
                "type": "vec3",
                "label": "Position",
                "description": "Absolute local position `[x, y, z]` (relative to parent). Omit → authored position.",
                "optional": true
              },
              {
                "key": "rotation",
                "type": "vec4",
                "label": "Rotation",
                "description": "Absolute local rotation as a unit quaternion `[x, y, z, w]`. Omit → authored rotation. Interpolated with slerp.",
                "optional": true
              },
              {
                "key": "scale",
                "type": "vec3",
                "label": "Scale",
                "description": "Absolute local scale `[x, y, z]` (`[0,0,0]` = collapse to zero size). Omit → authored scale. Use `active: false` to fully disable the object.",
                "optional": true
              }
            ],
            "description": "Entry pose for objects becoming active (inactive → active). When the runtime\ntransitions an object from `active:false` to `active:true` with `enterFrom`\nset, the \"from\" pose for transform interpolation is this **absolute local\npose** instead of the live pose (omitted fields fall back to the target pose).\nSame absolute semantics as `transform`.",
            "optional": true
          },
          {
            "key": "transition",
            "type": "string",
            "label": "Transition",
            "description": "Transition config for entering this state.\n\n- **Time-driven** (`{ duration, easing?, delay? }`): animates over a fixed duration\n- **Property-driven** (`{ driver, range?, easing? }`): progress tracks a live value\n\nWithout a transition, values snap immediately.",
            "optional": true
          }
        ],
        "isMap": true,
        "description": "Named states — conditional property value overrides with optional\ntransform overrides and transitions.\n\n**Pseudo-states** (names starting with `:`) auto-trigger from events:\n- `:hover` — pointer enters/exits the object\n- `:active` — pointer is pressed on the object\n- `:selected` — object is selected via click-to-select\n\n**Custom states** are activated programmatically via `setState()` or `initialState`.\n\nStates stack by priority: `:active` (40) > `:selected` (30) > `:hover` (20) > custom (10).\nPer-property, the highest-priority state providing a value wins.",
        "optional": true
      },
      {
        "key": "initialState",
        "type": "string",
        "label": "Initial State",
        "description": "State name to activate when the scene enters play mode.\nMust reference a key in `states`. Useful for property-driven transitions\nthat should be active from the start (e.g. camera-distance effects).",
        "optional": true
      },
      {
        "key": "stateGroup",
        "type": "boolean",
        "label": "State Group",
        "description": "When `true`, this object OWNS its state group and is a *group boundary*. Its\nstate list is independent of any group above it, so an outer group's state\ncoordination (add / rename / delete / switch fan-out) stops at this object and\ndoes not reach into its subtree. This is what lets, e.g., a model keep its own\n\"separated\" states while sitting inside an ancestor group, the two combining\nindependently.\n\n**Runtime-load-bearing.** `trace/setState(target, s)` is a SCOPED runtime op:\nit walks the target's subtree and sets every participating descendant's slot,\npruning at `stateGroup` boundaries (see docs/canopy/STATE_SCOPE_SPEC.md §3 and\ncore/canopy/stateScope.ts). Runtimes MUST honor this marker (a boundary and\nits subtree are excluded from an ancestor's scoped set); exporters MUST\npreserve it. A plain boolean marker — the group is identified by the object,\nnot a separate axis name. See docs-internal/STATE_GROUP_BOUNDARIES.md.",
        "optional": true
      }
    ],
    "docs": "### Properties (discriminator: `type`)\n\nBase interface for all property declarations.\n\n**Common fields** (shared by all variants):\n- `name`: string — Property identifier — used in `{name}` bindings and state value overrides\n- `label`: string (optional) — Display label for editor UI. Makes the property discoverable by AutoUI.\n- `hidden`: boolean (optional) — Keep the property out of generated controls (AutoUI). It stays declared,\n  bindable and editable in an inspector — this is for values that are\n  *driven* rather than adjusted: a page's deck height set by page\n  selection, a compiled offset. Runtimes ignore it.\n- `inherits`: boolean (optional) — Whether this property inherits its value from an ancestor.\n  - `true` (default): \"I inherit from my parent\" — ancestor value wins.\n  - `false`: \"I don't inherit\" — local value wins, ancestor walk skipped.\n  Like CSS `@property { inherits }`, but per-declaration rather than global.\n- `transition`: TimeTransition (optional) — Default transition for programmatic value changes (CSS: `transition: color .3s`).\n  Precedence: an initiator's explicit transition (a state's `transition`, a\n  graph edge's config, a `setValue` argument) wins; this is the fallback; no\n  transition anywhere = snap. Never consulted for instant (snap) recomputes.\n  Time-driven only by type.\n\n| `type` | Description | Extra fields | Requirements |\n|---|---|---|---|\n| `string` | String property declaration | `value`: string, `kind?`: StringPropertyKind | — |\n| `number` | Numeric property declaration with optional constraints for editor UI. | `value`: number, `units?`: Units, `min?`: number, `max?`: number, `step?`: number, `uiHint?`: 'slider' | 'input' | — |\n| `boolean` | Boolean property declaration | `value`: boolean | — |\n| `vec3` | 3D vector property declaration | `value`: [number, number, number], `units?`: Units | — |\n| `vec4` | 4D vector property declaration for generic 4-component data (RGBA, weights, etc.) | `value`: [number, number, number, number] | — |\n| `color` | Color property declaration (hex string) | `value`: string, `variants?`: { name: string; value: string }[] | — |"
  },
  {
    "type": "Provenance",
    "description": "Provenance behavior data.\n\nInert: nothing in the runtime reads this, and nothing renders from it. It\nexists so a finished scene can answer \"what made you\" — for remixing, for\nattribution, and so the artifacts of a generation run stay attached to the\nscene instead of to a sidecar file that gets separated from it.",
    "fields": [
      {
        "key": "source",
        "type": "enum",
        "label": "Source",
        "options": [
          "trace-ai",
          "remix",
          "import"
        ],
        "description": "What produced the scene.",
        "optional": true
      },
      {
        "key": "prompt",
        "type": "string",
        "label": "Prompt",
        "description": "The creator's own words. Verbatim — never normalized or truncated.",
        "optional": true
      },
      {
        "key": "mode",
        "type": "string",
        "label": "Mode",
        "description": "Generation mode, e.g. `auto` / `template` / `scratch`.",
        "optional": true
      },
      {
        "key": "template",
        "type": "string",
        "label": "Template",
        "description": "Template slug that answered, e.g. `card-feature`. Never a model id.",
        "optional": true
      },
      {
        "key": "style",
        "type": "string",
        "label": "Style",
        "description": "Style slug applied to the root, e.g. `aurora`.",
        "optional": true
      },
      {
        "key": "label",
        "type": "string",
        "label": "Label",
        "description": "Role label for display, e.g. \"Trace AI · layout\".\n\nDeliberately the same label the generator already shows a creator, and\ndeliberately not a model name: which model answered is a routing detail\nthat changes under us, and baking it into published scenes would turn\nevery routing change into a fleet of stale claims.",
        "optional": true
      },
      {
        "key": "generatedAt",
        "type": "string",
        "label": "Generated At",
        "description": "ISO-8601 timestamp of the run.",
        "optional": true
      },
      {
        "key": "remixOf",
        "type": "string",
        "label": "Remix Of",
        "description": "The scene this one was derived from, when it was derived from one.",
        "optional": true
      },
      {
        "key": "assets",
        "type": "array",
        "label": "Assets",
        "itemFields": [
          {
            "key": "ref",
            "type": "string",
            "label": "Ref",
            "description": "The reference recorded when this asset was generated.\n\nThis is inert generation history, not a file dependency. Export carries\nthe assets record without fetching or rewriting its values; the scene\nnode that actually uses an asset owns validation and bundling. Legacy\nrecords named this field `src`; their metadata is carried the same way."
          },
          {
            "key": "via",
            "type": "string",
            "label": "Via",
            "description": "How it was made: a generator slug (`imagegen`, `trellis2`), or `catalog` when it was found rather than made."
          },
          {
            "key": "prompt",
            "type": "string",
            "label": "Prompt",
            "description": "The instruction behind it, when it had one of its own."
          }
        ],
        "itemLabel": "Provenance Asset",
        "description": "Generated art and models with their recorded references (see `ProvenanceAsset.ref`).",
        "optional": true
      },
      {
        "key": "bakedFrom",
        "type": "string",
        "label": "Baked From",
        "description": "The asset this object's `src` was baked FROM — its authored, still-rigged\noriginal.\n\nExport bakes live deformation into geometry and points `src` at a\ngenerated `morphbake_<hash>.glb`, which renders correctly everywhere and\nre-edits nowhere: the morph targets are gone, so a re-imported component\ncan never be re-stretched. This records the way back. A Bevel'd\nprimitive bakes the same way, to `bevel_<host>_<hash>.glb`, and records\nthe primitive under the modifier (`builtin:primitive_cube.glb`), so an\nauthoring load reopens that primitive with its Bevel instead of a Model\non the bake. An extruded Text's body bakes to `text3d_<hash>.glb` and\nrecords `builtin:none`: there was no `src`, and an authoring load opens\nnone, so the Text builds its body again.\n\nTrue only beside the bake it was written with. Every bake writes it from\nthe src it replaces, so a form swapped in since the last save is what the\nnext re-open gets. A src that is itself a bake keeps the note it came\nwith — the rig, not the previous bake; with none, a Bevel bake (a rounded\nprimitive, still stretchable) is recorded and a deformation bake is not.\nBeside any other src the note is\ndropped on export and ignored on load: it names a form the object no\nlonger has.\n\nUnlike ProvenanceAsset.ref — inert generation history — this\nnames an asset that may exist ONLY here, so the\nexport bundles it like any other reference. That is the cost of\nre-editability: the archive carries the baked geometry and the rig it\nwas baked from.\n\nRead only when a load declares itself an authoring session\n(`ConfigData.playMode === false`); a runtime carries it untouched and\nrenders the baked `src`, which is the published contract.",
        "optional": true
      },
      {
        "key": "placedFrom",
        "type": "string",
        "label": "Placed From",
        "description": "The reference this content was placed from, before unpack dissolved it.\n\nPlacing a library asset or a `.trace` leaves a reference: one wrapper\nnode whose `src` is the URL, with the file's content underneath as\nderived material. `unpack` (#730) is the inverse — the content becomes\nthe scene's own and the wrapper goes away, and with it the only record\nthat any of this came from somewhere. This is that record.\n\nStamped **only on unpack** (spec §3.4). A plain import does not need it:\nthe reference node is still standing and still carries the URL, so a\nsecond copy could only rot out of step with the first. Editors read it\nfor \"placed from <asset>\" provenance and to offer a re-link; nothing\nfetches it and nothing renders from it.\n\nAlways an absolute http(s) URL, so for a library reference it is an\nasset file URL and `parseAssetFileUrl` recovers the id. Deliberately not\na local `assets/…` path: an unpack with no URL behind it has no\nprovenance to record, and a local path here would be a second, weaker\nname for bytes the archive already carries.",
        "optional": true
      }
    ]
  },
  {
    "type": "RecordingInfo",
    "fields": [
      {
        "key": "formatVersion",
        "type": "number",
        "label": "Format Version",
        "default": 2,
        "step": 1,
        "min": 1,
        "description": "Recording format version. `2` for recordings that live inside a scene\ndocument (this format)."
      },
      {
        "key": "capturedAt",
        "type": "string",
        "label": "Captured At",
        "description": "When capture started, as an ISO-8601 timestamp (e.g. `2026-09-26T14:03:11Z`).",
        "optional": true
      },
      {
        "key": "author",
        "type": "object",
        "label": "Author",
        "fields": [
          {
            "key": "id",
            "type": "string",
            "label": "Id",
            "description": "The author's user id.",
            "optional": true
          },
          {
            "key": "name",
            "type": "string",
            "label": "Name",
            "description": "The author's display name at capture time.",
            "optional": true
          }
        ],
        "description": "Who made the recording.",
        "optional": true
      },
      {
        "key": "device",
        "type": "string",
        "label": "Device",
        "description": "The capturing device, informational (e.g. `iPhone15,2`).",
        "optional": true
      },
      {
        "key": "app",
        "type": "string",
        "label": "App",
        "description": "The capturing app and version, informational.",
        "optional": true
      },
      {
        "key": "capture",
        "type": "object",
        "label": "Capture",
        "fields": [
          {
            "key": "face",
            "type": "enum",
            "label": "Face",
            "options": [
              "arkit",
              "none"
            ],
            "description": "Face source: `arkit` for ARKit blendshapes, `none` for a recording with\nno face (Android, a sequence-only recording).",
            "optional": true
          },
          {
            "key": "clock",
            "type": "enum",
            "label": "Clock",
            "options": [
              "arframe",
              "frame"
            ],
            "description": "Key timestamps: `arframe` when keys carry the ARKit frame timestamp\n(§3.1), `frame` when they carry a render-frame clock (v1 conversions).",
            "optional": true
          }
        ],
        "description": "How the data was captured and stamped.",
        "optional": true
      },
      {
        "key": "frame",
        "type": "object",
        "label": "Frame",
        "fields": [
          {
            "key": "origin",
            "type": "enum",
            "label": "Origin",
            "options": [
              "head",
              "scene"
            ],
            "description": "`head`: origin at the first performer's first head position, +Y up, and\n+Z the horizontal facing of that head. `scene`: no head pose to anchor\nto (voice- or tracks-only); the frame is the capture scene's canonical\nanchor frame.",
            "optional": true
          },
          {
            "key": "up",
            "type": "enum",
            "label": "Up",
            "options": [
              "gravity",
              "scene"
            ],
            "description": "Where +Y came from: `gravity` (a native recorder: ARKit's\ngravity-aligned world) or `scene` (a v1 conversion: the canonical anchor\nframe's +Y, assumed level).",
            "optional": true
          },
          {
            "key": "startHeight",
            "type": "number",
            "label": "Start Height",
            "description": "The first head position's height above the capture scene's origin, in\nmetres. A placement hint: the `Recording` node marks where the head\nstarts, so an editor dropping the recording on a floor can raise it by\nthis much.",
            "optional": true
          }
        ],
        "description": "How the recording frame was chosen (§3.2).",
        "optional": true
      },
      {
        "key": "migratedFrom",
        "type": "string",
        "label": "Migrated From",
        "description": "The v1 scene-content id this recording was converted from (§9). Absent\n— or `null`, which a scene save drops — for a native recording.",
        "optional": true
      }
    ]
  },
  {
    "type": "Renderer",
    "description": "Controls shadow casting and materials for renderers",
    "fields": [
      {
        "key": "castShadows",
        "type": "boolean",
        "label": "Cast Shadows",
        "default": true,
        "description": "Whether renderer casts shadows"
      },
      {
        "key": "materials",
        "type": "array",
        "label": "Materials",
        "itemFields": [
          {
            "key": "src",
            "type": "string",
            "label": "Src",
            "description": "Source URL or path to the material GLB file\nOptional - only included when material replacement is applied\nExcluded when only property changes (color/UV) are made"
          },
          {
            "key": "targetMaterialIndex",
            "type": "number",
            "label": "Target Material Index",
            "step": 0.01,
            "default": 0,
            "description": "Target material slot index (0-based).\n\nThis is a MESH slot index, not a glTF material index: slots are enumerated\nper mesh, so meshes that shared one authored glTF material appear as\nseveral slots. Editors must therefore fan a single material choice out\nacross every slot carrying that original material."
          },
          {
            "key": "baseColorFactor",
            "type": "color",
            "label": "Base Color Factor",
            "description": "Base color, #RRGGBB or #RRGGBBAA. An alpha byte below FF alpha-blends this slot on its own; 00 hides it without writing depth."
          },
          {
            "key": "opacity",
            "type": "number",
            "label": "Opacity",
            "step": 0.01,
            "default": 1,
            "description": "Opacity of this slot alone (0 = fully transparent, 1 = fully opaque).\nAbsent, or 1, leaves the slot's material as the model authored it; `0` is\na real value and hides the slot without writing depth.\n\nBelow 1 the slot alpha-blends on its own copy of the material, so the\nobject's other slots and other placements of the same model are\nuntouched. It multiplies with the whole-object `opacity` and with the alpha\nbyte of a `#RRGGBBAA` `baseColorFactor` on the same slot: the slot's alpha\nis slot opacity × object opacity × colour alpha. Withdrawing it, or setting\n1, hands the material's authored transparency back. An occluder material\nignores it.\n\nPublished files carry it in `Renderer.materials[]` like any other slot\noverride, and a baked GLB also carries the resulting alpha on the slot's\nmaterial (`baseColorFactor[3]` with `alphaMode: BLEND`). A player that\ndoes not read this field shows the slot at its authored alpha."
          },
          {
            "key": "roughnessFactor",
            "type": "number",
            "label": "Roughness Factor",
            "step": 0.01,
            "default": 0,
            "description": "PBR roughness factor (0 = mirror-smooth, 1 = fully diffuse).\nReplaces the material's authored roughness for this slot.\nAbsent = keep whatever the material authored; `0` is a valid override."
          },
          {
            "key": "metallicFactor",
            "type": "number",
            "label": "Metallic Factor",
            "step": 0.01,
            "default": 0,
            "description": "PBR metallic factor (0 = dielectric, 1 = metal).\nReplaces the material's authored metallic for this slot.\nAbsent = keep whatever the material authored; `0` is a valid override."
          },
          {
            "key": "emissiveFactor",
            "type": "string",
            "label": "Emissive Factor",
            "description": "Emissive color, #RRGGBB (a trailing alpha byte is accepted and ignored).\nReplaces the material's authored emissive for this slot; `#000000` is a\nvalid override meaning \"not emissive\".\n\nThe glow a screen, a sign or a filament has on its own, independent of\nscene lighting — the same quantity glTF core calls `emissiveFactor`, so\nan exported scene carries it in vanilla glTF with no extension.\nAbsent = keep whatever the material authored."
          },
          {
            "key": "texture_transform",
            "type": "string",
            "label": "Texture_transform",
            "description": "Texture transform settings for UV scaling"
          }
        ],
        "itemLabel": "Material Data",
        "description": "Array of materials applied to this renderer\nEach material corresponds to a material slot on the 3D object",
        "optional": true
      },
      {
        "key": "pickThrough",
        "type": "boolean",
        "label": "Pick Through",
        "default": false,
        "description": "Let pointer picks pass through this object's own meshes in play mode,\nincluding its colliders and embedded controls. Child SceneObjects retain\ntheir own policy. Edit-mode selection is unchanged. Independent of opacity."
      },
      {
        "key": "opacity",
        "type": "number",
        "label": "Opacity",
        "default": 1,
        "description": "Whole-object opacity (0 = fully transparent, 1 = fully opaque).\nAutomatically manages transparency mode on all meshes; multiplies into a slot's own `opacity`\nand into a slot whose baseColorFactor carries its own alpha."
      },
      {
        "key": "tint",
        "type": "string",
        "label": "Tint",
        "description": "Whole-model tint (#RRGGBB or #RRGGBBAA hex; a trailing alpha byte is\naccepted but ignored — use `opacity` for transparency). Multiplies into\nevery material's authored base color across ALL slots — GLB-authored\ntextured materials included — unlike the per-slot material color, which\nreplaces one slot's color. Empty or absent = no tint.",
        "optional": true
      }
    ]
  },
  {
    "type": "RestRelativeBinding",
    "fields": [
      {
        "key": "nodes",
        "type": "string",
        "label": "Nodes",
        "arrayOf": "string",
        "default": [],
        "description": "Node names in the bound instance whose bound rotations are rest-relative."
      }
    ]
  },
  {
    "type": "Rotatable",
    "description": "Marks an object as rotatable by the user",
    "fields": [
      {
        "key": "axes",
        "type": "multiSelect",
        "label": "Axes",
        "options": [
          "x",
          "y",
          "z"
        ],
        "description": "Allowed rotation axes. When omitted, all axes are allowed.",
        "optional": true
      },
      {
        "key": "momentumDamping",
        "type": "number",
        "label": "Momentum Damping",
        "default": 0,
        "min": 0,
        "description": "Release momentum (\"spin it and let go\"): after a drag ends, the spin\nkeeps going and eases out with this time constant in seconds — the rate\ndecays to ~37% per interval, and the total extra sweep is release-rate ×\nthis value. 0 or absent = stops dead on release (classic behavior).\nSame seconds vocabulary as Billboard/Tether damping. Cross-platform\ncontract: docs-internal/MANIPULATION_MOMENTUM_SPEC.md."
      }
    ]
  },
  {
    "type": "Rotate",
    "description": "Continuous rotation animation applied to the animation root",
    "fields": [
      {
        "key": "axis",
        "type": "enum",
        "label": "Axis",
        "options": [
          "x",
          "y",
          "z",
          "Random"
        ],
        "default": "y",
        "description": "Rotation axis. \"Random\" picks a random normalized axis on attach."
      },
      {
        "key": "speed",
        "type": "number",
        "label": "Speed",
        "default": 45,
        "step": 5,
        "description": "Base rotation speed in degrees per second"
      },
      {
        "key": "speedRange",
        "type": "number",
        "label": "Speed Range",
        "default": 0,
        "step": 10,
        "description": "Speed randomization range (+/-). Runtime speed = speed ± random(speedRange).\nFor example, speed=180 and speedRange=60 gives a runtime speed in [120, 240]."
      }
    ]
  },
  {
    "type": "SphereCollider",
    "description": "Sphere-shaped collider for physics and interaction detection",
    "fields": [
      {
        "key": "radius",
        "type": "number",
        "label": "Radius",
        "default": 0.5,
        "step": 0.1,
        "description": "Radius of the sphere collider"
      },
      {
        "key": "center",
        "type": "vec3",
        "label": "Center",
        "default": [
          0,
          0,
          0
        ],
        "description": "Center offset of the collider relative to the transform"
      }
    ]
  },
  {
    "type": "Synth",
    "description": "Oscillator-based synthesizer with ADSR envelope and spatial audio",
    "fields": [
      {
        "key": "waveform",
        "type": "enum",
        "label": "Waveform",
        "options": [
          "sine",
          "square",
          "sawtooth",
          "triangle"
        ],
        "default": "sine",
        "description": "Oscillator waveform shape"
      },
      {
        "key": "note",
        "type": "number",
        "label": "Note",
        "default": 60,
        "step": 1,
        "min": 0,
        "max": 127,
        "description": "Default MIDI note number (0–127). Middle C = 60.\nIgnored when frequency is set."
      },
      {
        "key": "frequency",
        "type": "number",
        "label": "Frequency",
        "step": 1,
        "min": 20,
        "max": 20000,
        "description": "Frequency in Hz. When set, overrides the MIDI note value.",
        "optional": true
      },
      {
        "key": "volume",
        "type": "number",
        "label": "Volume",
        "default": 0.5,
        "step": 0.05,
        "min": 0,
        "max": 1,
        "description": "Master volume (0–1)"
      },
      {
        "key": "attack",
        "type": "number",
        "label": "Attack",
        "default": 0.01,
        "step": 0.01,
        "min": 0,
        "max": 5,
        "description": "Envelope attack time in seconds (ramp from 0 to peak)"
      },
      {
        "key": "decay",
        "type": "number",
        "label": "Decay",
        "default": 0.1,
        "step": 0.01,
        "min": 0,
        "max": 5,
        "description": "Envelope decay time in seconds (ramp from peak to sustain level)"
      },
      {
        "key": "sustain",
        "type": "number",
        "label": "Sustain",
        "default": 0.7,
        "step": 0.05,
        "min": 0,
        "max": 1,
        "description": "Envelope sustain level (0–1). Held after decay until release."
      },
      {
        "key": "release",
        "type": "number",
        "label": "Release",
        "default": 0.3,
        "step": 0.01,
        "min": 0,
        "max": 10,
        "description": "Envelope release time in seconds (ramp from sustain to 0)"
      },
      {
        "key": "duration",
        "type": "number",
        "label": "Duration",
        "default": 0.5,
        "step": 0.1,
        "min": 0,
        "max": 30,
        "description": "Auto-release after this many seconds. 0 = sustain indefinitely until stop()."
      },
      {
        "key": "spatial",
        "type": "boolean",
        "label": "Spatial",
        "default": true,
        "description": "Enable 3D spatial audio (PannerNode positioned at object transform)"
      },
      {
        "key": "minDistance",
        "type": "number",
        "label": "Min Distance",
        "default": 1,
        "step": 0.5,
        "min": 0,
        "description": "Spatial: distance at which volume is at maximum"
      },
      {
        "key": "maxDistance",
        "type": "number",
        "label": "Max Distance",
        "default": 50,
        "step": 1,
        "min": 0,
        "description": "Spatial: distance at which volume reaches zero"
      },
      {
        "key": "rolloff",
        "type": "number",
        "label": "Rolloff",
        "default": 1,
        "step": 0.1,
        "min": 0,
        "max": 10,
        "description": "Spatial: how quickly volume attenuates with distance"
      },
      {
        "key": "playOnStart",
        "type": "boolean",
        "label": "Play On Start",
        "default": false,
        "description": "Automatically play the default note when play mode starts"
      }
    ]
  },
  {
    "type": "Tether",
    "description": "Makes an object continuously follow the user or another object",
    "fields": [
      {
        "key": "enabled",
        "type": "boolean",
        "label": "Enabled",
        "default": true,
        "description": "Whether following is active when play mode starts. When false the object\nstays put until the behavior graph enables it (trace/setBehaviorEnabled).\nDisabling at runtime stops it where it is; re-enabling re-runs `delay`.\nEvery play-mode start resets to this value."
      },
      {
        "key": "target",
        "type": "string",
        "label": "Target",
        "default": "",
        "description": "What to follow: a TransformPath to another scene object, or empty to\nfollow the user (the active camera)."
      },
      {
        "key": "keepDistance",
        "type": "number",
        "label": "Keep Distance",
        "default": 1,
        "description": "Comfort buffer in meters — the object stops approaching once within\nthis distance, and backs away when the target comes closer than\n75% of it."
      },
      {
        "key": "axes",
        "type": "multiSelect",
        "label": "Axes",
        "options": [
          "x",
          "y",
          "z"
        ],
        "description": "World axes the object may move along. Omit for all three. The classic\nAR panel follows on [\"x\",\"z\"] — trailing left/right and near/far while\nkeeping its authored height as the user squats or stands.",
        "optional": true
      },
      {
        "key": "speed",
        "type": "number",
        "label": "Speed",
        "default": 1.5,
        "description": "Maximum movement speed in meters per second."
      },
      {
        "key": "damping",
        "type": "number",
        "label": "Damping",
        "default": 0.25,
        "description": "Movement smoothing as a time constant in seconds — larger trails more\nsoftly (arrival eases in). 0 moves linearly at full speed."
      },
      {
        "key": "delay",
        "type": "number",
        "label": "Delay",
        "default": 0,
        "description": "Seconds the target must stay out of range before the object starts\nmoving — the natural \"notice, then catch up\" trail."
      }
    ]
  },
  {
    "type": "Text",
    "description": "Renders a string of text in 3D space.\n\nText is the canonical authoring primitive for labels, signage, captions, and\nany flat typographic content in a scene. The spec is engine-agnostic: every\nimplementation (Babylon, Unity, native) renders the same `TextData` to a\nvisually equivalent result, within font-availability constraints.\n\n## Units at a glance\n\n| Concept           | Unit                                                |\n|-------------------|-----------------------------------------------------|\n| `fontSize`        | Em-relative; `100` = 1 world-unit em-square         |\n| `strokeWidth`     | Em fraction (`0` – `0.05`)                          |\n| `letterSpacing`   | Em units (fraction of `fontSize` em-square)         |\n| `lineHeight`      | Multiplier of em-square (CSS-style)                 |\n| `color`           | Hex `#RRGGBB` or `#RRGGBBAA`                        |\n| `opacity`         | Alpha multiplier (`0` – `1`) on fill and stroke     |\n| `depth`           | Em units (extrusion behind the glyphs)              |\n\nEverything sized \"relative to text\" is expressed in **em units** — fractions\nof the `fontSize` em-square. This is the same convention used by CSS, web\ntypography, and the major 3D text libraries (troika-three-text, Unity TMP\nrich text, RealityKit). One ruler for size, stroke, and tracking.\n\n## Font Size — em-square model\n\n`fontSize` measures the **em-square** in centi-world-units. `fontSize: 100`\nis a 1 world-unit (1 metre) em-square. Visible cap-height (the height of\n`H`, `E`) depends on the typeface — typical sans-serifs render `H` at\nroughly 70% of em, so `fontSize: 100` produces a visible cap of ~70 cm in\nRoboto, ~75 cm in a display face like Anton, ~66 cm in a slim serif.\n\nThis is the same model as CSS `font-size: 16px`: setting a single fontSize\nacross multiple typefaces produces visibly different letter heights, and\nthat variance is part of what makes typefaces distinctive. Authors who\nwant consistent visible letter heights across families pick faces with\nsimilar cap-height ratios (Roboto and Inter, both ≈0.71, are close enough\nto be interchangeable at the same `fontSize`).\n\n### Sizing reference for typical sans-serifs (1 world-unit = 1 metre)\n\n| `fontSize` | Em-square | Visible cap (`H`) | Use case                             |\n|-----------:|----------:|------------------:|--------------------------------------|\n| `0.9`      | 9 mm      | 6 mm              | Comfortable reading at 45 cm (palm)  |\n| `3.5`      | 35 mm     | 25 mm             | Comfortable reading at 2 m           |\n| `7`        | 7 cm      | 5 cm              | Small labels                         |\n| `14`       | 14 cm     | 10 cm             | Arm's-length signage (default)       |\n| `28`       | 28 cm     | 20 cm             | Large signage                        |\n| `100`      | 1 m       | ~70 cm            | Architectural scale                  |\n\nThe cap-height column reflects Microsoft's MR legibility recommendations:\n`fontSize: 14` produces ~10 cm visible H, comfortable at arm's-length;\n`fontSize: 3.5` ≈ 25 mm visible H, comfortable at 2 m.\n\n## Anchoring\n\n`anchorX` and `anchorY` together specify where the SceneObject origin sits\nwithin the rendered text box, *and* — for multi-line text — how lines are\naligned with respect to one another.\n\n- `anchorX: \"left\"` — origin at the left edge; lines left-aligned.\n- `anchorX: \"center\"` — origin at the horizontal centre; lines centred.\n- `anchorX: \"right\"` — origin at the right edge; lines right-aligned.\n- `anchorY: \"top\"` — origin at the top of the first line: the face's cap line (see \"The text box\").\n- `anchorY: \"middle\"` — origin at the vertical centre of the box.\n- `anchorY: \"bottom\"` — origin at the bottom of the last line.\n\nDefault `(\"center\", \"middle\")` matches a freestanding 3D label. For a label\npinned to a marker, set `anchorY: \"bottom\"` so the text floats above the\npinned point.\n\nThe conflation of \"horizontal anchor\" and \"line alignment\" into one\n`anchorX` field is deliberate: in 3D space the two are almost always\ndesired together. Authors needing them split (e.g. left-aligned lines\ninside a centred box) compose with a parent transform offset.\n\n## The text box — line boxes, not ink\n\nThe rendered text box (what `anchorX`/`anchorY` anchor, what the Layout\nsystem measures, what editors show) is the CSS-style **line-box** rect:\nevery line contributes exactly `lineHeight × fontSize` of height, so a\nparagraph's box is `lineCount × lineHeight × fontSize` tall regardless of\nwhich glyphs it contains — two same-fontSize labels get the same height\nwhether or not one has a descender, and leading is part of the box. Width\nis the widest line's advance width. (The tight ink bounds of the actual\nglyph quads are an implementation detail, not the box.)\n\nA top-anchored box starts at the face's cap line. A face keeps empty space\nbetween its line top and its capitals (a quarter to a third of an em in the\nbundled faces), and with `anchorY: \"top\"` the box does not begin there: it\nbegins at the top of the face's capital H, so a capital's ink, not the\nface's spare ascent, sits on the anchor. That depth is one number per face,\nread from the font and never from the text: editing \"Once\" to \"once\", or\nemptying the first line, does not move the paragraph, and ink taller than a\ncapital (ascenders, accents, brackets) rises above the box as a descender\nfalls below it. A face with no H uses 0.3 of its ascent, and one with no\nbaseline either starts at the line top. The other anchors\nare unchanged, and the box's height and centre are the same for every\nanchor, measured with or without a font atlas.\n\n## Wrapping & sizing\n\nStandalone text is intrinsic-size: explicit `\\n` breaks only, box as\nabove. **`TextData` has no `maxWidth` of its own.** Wrapping is\ndelegated to the Layout system: place a Text behavior on a SceneObject\nthat also has a `LayoutItem`, and the layout-resolved width — a Fixed\nwidth, a Fill share, or a Stretch cross-axis slot — is the wrap width.\nThis separation mirrors CSS (a `<span>` is intrinsic; a sized container\nwraps its inline content) and avoids duplicating sizing semantics. Text\nwhose width is Hug has nothing to wrap against and stays on one line per\nexplicit break, unless its `LayoutItem` authors a `maxWidth`: a Hug\n`maxWidth` is a wrap ceiling, inside a Layout or standalone, and a\nnarrower ancestor width still wins. A ceiling only limits wrapping. It is\nnot a slot, so short `anchorX: \"left\"` / `\"right\"` text keeps its own box\nand does not move.\n\nWrapping is greedy and space-delimited: an explicit line that fits its\nconstraint stays verbatim; one that doesn't is re-broken at spaces, and a\nsingle word wider than the constraint overflows on its own line — no\nhyphenation and no mid-word breaking. Spaces render verbatim as everywhere\nelse in this spec; the ones a break lands on stay with the line above and\nhang past its end, so they never widen the paragraph.\n\nSet `wrap: false` to opt a node out (buttons, badges): its glyphs then\nignore the resolved width and may overflow the slot.\n\nA wrapped paragraph reports `lineCount × lineHeight × fontSize` for the\nlines it actually broke into, so a Hug-height container around it sizes to\nthe wrapped text.\n\nExport writes the solved constraint as `bakedWrapWidth` so players without\nlayout wrap at the same width. It is metres in the text node's local frame,\nbefore TRS, and is omitted when wrapping is disabled or unconstrained. It\nrecords the wrap width only: the slot, or a Hug `maxWidth` ceiling. It is\nnever the anchoring slot, so a player aligns anchored text to the text's\nown box. Authoring clients ignore this bake, re-solve the retained\nLayout/LayoutItem, and replace it on save. Export writes the bake for a Hug\n`maxWidth` ceiling too, so a player that reads the bake needs nothing more.\nA player uses a positive finite bake first, otherwise its own Fixed\nLayoutItem width; `wrap: false` disables either constraint.\n\n## Stroke / outline\n\n`strokeWidth` is a fraction of em (`0` – `0.05`). At `fontSize: 100` this\nrange covers a 0–5 cm outline. The outline scales with `fontSize`, so\n`strokeWidth: 0.02` looks the same proportional weight at small and large\nsizes. Engines internally translate to whatever their renderer needs\n(signed-distance offset, geometric stroke, etc.).\n\nThe upper bound of `0.05` reflects the analytic saturation point of an\nMSDF field, not the visible result with any specific atlas. Each font\natlas's distance range determines the actual visible ceiling: the\nbundled Roboto Regular (distance range 4 px) saturates around `0.02` —\nvalues between `0.02` and `0.05` continue to mean what they mean\nmathematically, but render the same as the saturation point. Higher-\nresolution atlases in a future revision may extend the visible range;\nthe unit (em fraction) is fixed.\n\nThe outline fades with the text: `opacity` multiplies the alpha of\n`strokeColor` exactly as it does the fill's, so at `opacity: 0` nothing of\nthe text is drawn, whether or not a stroke is set.\n\n## Depth (extruded text)\n\n`depth` gives the text a solid body behind its glyphs, `depth` em deep\n(`depth × fontSize / 100` world units), so a title reads as an object\nrather than a decal. `0` (the default)\nis flat text. A value outside `0` – `1` (a bound one) clamps to that range.\n\nThe flat glyphs stay the face: they draw exactly as without `depth`, with\nthe same colour, stroke and opacity. The body is a closed solid of the same\noutlines, filled by the non-zero rule, in the fill colour on a lit\nmaterial. Its walls carry the depth cue. Its front sits behind the glyph\nplane (−Z in the node's frame) by 2% of the em, at most half a millimetre,\nso the glyphs never z-fight it.\n\nA stroked text's body follows its stroke: the outlines grow by the stroke\n(round joins, as the outline draws), up to the widest stroke the face's\natlas can draw (half its distance range, 0.025 em for the bundled faces),\nand the body takes `strokeColor`, so the outline continues down the walls.\nUnstroked, the body is the glyphs' own outline in `color`.\n\n`depth` does not move the text box: width, height, anchoring and wrapping\nare as above, and layout gives the node the body's thickness, `depth` em\nplus the set-back, from the data alone: a title with nothing to\noutline (spaces) keeps its thickness and draws no body.\n\nExport bakes the body to a plain glTF mesh, the node's `src`\n(`text3d_<key>.glb`), so a player draws the Text it already draws and the\nbody as ordinary geometry: a client needs no extruder to show `depth`. An\nauthoring load drops the baked `src` and builds the body again from the\nText. This engine also builds it for a file that carries `depth` without a\nbake. Only faces that carry glyph outlines (the bundled families) have a\nbody; a hosted family renders flat, with no thickness.\n\n### Building the body\n\nA player only draws the bake. An engine that authors `depth` builds the\nsame body like this (Babylon: `behaviors/text/textBodyGeometry.ts`; the\nlibraries it uses, Clipper2 and earcut, are C# originals or have C#\nports):\n\n1. Lay the paragraph out as for the glyphs (advances, kerning, wrapping,\n   anchoring), in the atlas's font units (`info.size` per em).\n2. Take each glyph's outline from the face's outline file\n   (`assets/fonts/outlines/<face>.json`: `{ glyphs: { \"<codepoint>\":\n   \"<path>\" } }`, SVG-style `M L Q C Z` commands in font units, y up, from\n   the pen position and the line top). A glyph laid out at `(x, y)` has its\n   outline at `(x + px, 1 − y + py)`. A glyph with no entry has no body.\n3. Flatten curves to within 1/1600 em, union the contours by the non-zero\n   rule, and, for a stroked text, grow them by the stroke with round joins\n   (capped as above).\n4. Walls: a quad per boundary edge, from the front cap to the back cap, its\n   normal outward; edges meeting at under 30° share a normal. Caps:\n   each outline triangulated with its holes, facing +Z in front and −Z\n   behind. Faces wind counter-clockwise seen from outside.\n5. Scale font units to metres by `fontSize / 100 / emSize`, apply the\n   anchor's y offset, and place the front cap at the set-back and the back\n   cap `depth × fontSize / 100` behind it.\n6. Material: lit PBR, metallic 0, roughness 0.6, base colour the body's\n   colour above (linear), its alpha times `opacity`.\n\n## Physical interpretation in scaled hierarchies\n\n`fontSize` measures in the SceneObject's *local* coordinate system. When\na parent transform applies a non-identity scale, the rendered text scales\nwith it — `fontSize: 14` (~10 cm visible cap) inside a parent scaled by\n0.5 renders at ~5 cm. This is the same property as every other world-unit\ndimension in the scene graph: physical-unit interpretations are accurate\nonly when no ancestor scales the SceneObject. Layout integration in a\nfuture revision may opt to override `fontSize` for fitted-text use cases;\nin this RC, `fontSize` is always the intrinsic local-space size.\n\n## Font model\n\nFonts are referenced by **family name** (`fontFamily`) plus weight and\nstyle. Each engine ships its own atlas/asset for the supported families\n— there is no portable atlas format in this RC.\n\n**Families every engine carries (bundled):**\n\n| Family                | Variants               | Role                              |\n|-----------------------|------------------------|-----------------------------------|\n| `\"Roboto\"`            | regular, bold × R/I    | Default sans-serif (8 of 8)       |\n| `\"Inter\"`             | regular, bold × R/I    | UI-optimised sans-serif (8 of 8)  |\n| `\"Source Serif 4\"`    | regular, bold × R/I    | Serif for long-form/formal text   |\n| `\"JetBrains Mono\"`    | regular, bold × R/I    | Monospace for code/data/labels    |\n| `\"Oswald\"`            | regular, bold (no I)   | Condensed display for distance    |\n| `\"Bungee\"`            | regular only           | High-impact signage display       |\n| `\"Caveat\"`            | regular, bold (no I)   | Casual handwriting / annotations  |\n\n`bold` is one bundled face per family, not the whole 100–900 axis. A hosted\nfamily publishes whichever upstream weight its designer treats as its bold,\nso `fontWeight: \"bold\"` renders that family's own heavy rather than a\ngeneric 700.\n\nFamilies with partial coverage (Oswald, Caveat: no italics; Bungee: regular\nonly) participate in the standard fallback chain — requesting an unbundled\nvariant resolves to the family's nearest available face rather than a\nsynthesised oblique.\n\n**Hosted families.** `fontFamily` also accepts a name outside the table\nabove, provided the deployment has registered a face for it before the\nscene loads (Babylon: `loadFontPack` in `behaviors/text/hostedFonts.ts`,\nfed by a font-pack manifest from the asset library). A hosted face\nparticipates in the same fallback chain and is measured by the same rule as\na bundled one — its advance/kerning table is derived from the same BMFont\ndefinition the renderer draws from.\n\nAn engine MUST NOT treat an unregistered name as a rendering error; it falls\nback as above. Authoring tools MUST ask before emitting one — the family is\nrenderable iff the engine reports at least one variant for it.\n\n## Conformance requirements\n\nAn engine implementing this spec MUST:\n\n1. Read the font's **em-square size** and **natural line-height** from\n   font metrics. `fontSize` interpretation depends on the em-square.\n2. Support all values in the registry above for `fontFamily` /\n   `fontWeight` / `fontStyle`. Unknown values fall back to the default\n   family at the requested weight/style.\n3. Render the text box anchored according to `anchorX` / `anchorY` with\n   the SceneObject origin at the anchor point. For multi-line text, lines\n   align horizontally according to `anchorX`.\n4. Convert `letterSpacing` from em units to per-glyph advance offsets.\n5. Convert `strokeWidth` from em fraction to a visually consistent\n   outline at any `fontSize`.\n6. Multiply `opacity` into the alpha of the fill and stroke colours:\n   effective alpha = the colour's own alpha × `opacity`. Never replace the\n   colour's alpha. Clamp to `0` – `1`; an absent, non-numeric or unresolved\n   value is `1` (`0` is a real value).\n\nA player that does not read `opacity` shows the text at its authored colour\nalpha.\n\n## Non-goals (RC)\n\nOut of scope for this RC, reserved for future revisions: `textAlign`\n(split horizontal-alignment from anchor when authors actually need it),\n`textTransform`, `wordBreak` (hyphenation / mid-word breaking),\noverflow/truncation/ellipsis\n(`maxLines`), RTL / bidi `direction`, rich-text spans (mixed colours/sizes\nwithin one Text), non-Latin scripts (CJK, Arabic, Devanagari) — these are\natlas-prohibitive for MSDF and want a separate strategy. Layout-driven\nfontSize override (e.g. `fitToWidth`) is also reserved for the Layout RC.\nWeights beyond `regular`/`bold` are reserved: hosting makes further slots\ncheap for the first time, but widening the axis changes every existing\nscene's resolution chain.\n\n## References\n\n- CSS `font-size`, `text-align`, `letter-spacing`, `line-height`\n- Microsoft MR text guidelines:\n  https://learn.microsoft.com/en-us/windows/mixed-reality/develop/unity/text-in-unity\n- troika-three-text — closest analogue in the WebXR ecosystem",
    "fields": [
      {
        "key": "text",
        "type": "string",
        "label": "Text",
        "default": "Text",
        "description": "Text content to display. Use `\\n` for explicit line breaks.",
        "format": "multiline"
      },
      {
        "key": "fontFamily",
        "type": "enum",
        "label": "Font Family",
        "options": [
          "Roboto",
          "Inter",
          "Source Serif 4",
          "JetBrains Mono",
          "Oswald",
          "Bungee",
          "Caveat"
        ],
        "openEnum": true,
        "default": "Roboto",
        "description": "Font family name. One of the bundled families listed in this\nbehavior's docs, or the name of a family the deployment has registered\nfrom a hosted font pack. Unregistered names, or available names with\nmissing weight/style combinations, fall back along the chain\n`style → weight → family → default family at the requested\nweight/style → default`.\n\nDisplay families that ship without italics (Oswald, Caveat) or as\nsingle-weight only (Bungee) participate in the same fallback —\nauthoring `fontFamily: \"Oswald\", fontStyle: \"italic\"` resolves to\nOswald Regular, not a synthesised oblique."
      },
      {
        "key": "fontWeight",
        "type": "enum",
        "label": "Font Weight",
        "options": [
          "regular",
          "bold"
        ],
        "default": "regular",
        "description": "Font weight."
      },
      {
        "key": "fontStyle",
        "type": "enum",
        "label": "Font Style",
        "options": [
          "normal",
          "italic"
        ],
        "default": "normal",
        "description": "Font style."
      },
      {
        "key": "fontSize",
        "type": "number",
        "label": "Font Size",
        "default": 14,
        "step": 1,
        "description": "Font size, measured as the em-square in centi-world-units.\n`100` = 1 world-unit em-square. See sizing reference above."
      },
      {
        "key": "color",
        "type": "color",
        "label": "Color",
        "default": "#FFFFFF",
        "description": "Fill colour, hex `#RRGGBB` or `#RRGGBBAA`."
      },
      {
        "key": "opacity",
        "type": "number",
        "label": "Opacity",
        "hidden": true,
        "step": 0.01,
        "min": 0,
        "max": 1,
        "description": "Opacity of the whole text, `0` (invisible) to `1` (opaque), independent\nof `color`. Multiplies into the alpha of `color` and `strokeColor`, so it\nworks over a style-bound colour and can be bound to a property to differ\nper state or page. Absent means `1`.",
        "optional": true
      },
      {
        "key": "strokeColor",
        "type": "color",
        "label": "Stroke Color",
        "description": "Outline colour. Has no effect unless `strokeWidth > 0`.",
        "optional": true
      },
      {
        "key": "strokeWidth",
        "type": "number",
        "label": "Stroke Width",
        "default": 0,
        "step": 0.005,
        "min": 0,
        "max": 0.05,
        "description": "Outline thickness as a fraction of em. `0` = no outline,\n`0.01` = subtle, `0.02` = readable on busy backgrounds.\nVisually consistent across `fontSize`. Visible saturation depends\non the loaded font atlas — the bundled Roboto saturates around\n`0.02`; higher-resolution atlases extend further."
      },
      {
        "key": "depth",
        "type": "number",
        "label": "Depth",
        "default": 0,
        "step": 0.01,
        "min": 0,
        "max": 1,
        "description": "Extrusion depth behind the glyphs, in em (fraction of `fontSize`).\n`0` is flat text; `0.08` is a solid display title. See \"Depth\" above."
      },
      {
        "key": "anchorX",
        "type": "enum",
        "label": "Anchor X",
        "options": [
          "left",
          "center",
          "right"
        ],
        "default": "center",
        "description": "Horizontal anchor of the text box relative to the SceneObject origin.\nAlso controls line alignment for multi-line text:\n`left` aligns lines flush-left with the origin at the left edge,\n`center` centres lines with the origin at the horizontal centre,\n`right` aligns lines flush-right with the origin at the right edge.\n\n**Which box.** Inside a layout, the box this anchors is the node's\nresolved SLOT, not the glyph run: `left` puts the paragraph at the\nslot's left edge however wide the slot is, and `right` at its right\nedge. An engine that anchors the run instead centres a left-anchored\nparagraph in a wide slot, which is neither alignment. Where the layout\nresolved no width — standalone text, or a Hug width that is the text's\nown measurement — the box IS the run and the two agree. A Hug\n`maxWidth` ceiling limits wrapping but is not a slot, so it does not\nmove short anchored text. `center` is the\nsame answer either way, which is why the default is unaffected."
      },
      {
        "key": "anchorY",
        "type": "enum",
        "label": "Anchor Y",
        "options": [
          "top",
          "middle",
          "bottom"
        ],
        "default": "middle",
        "description": "Vertical anchor of the text box relative to the SceneObject origin.\n`top` puts the origin at the first line's cap line; `middle` at the\nvertical centre of the box; `bottom` at the bottom of the last line."
      },
      {
        "key": "lineHeight",
        "type": "number",
        "label": "Line Height",
        "default": 1.2,
        "step": 0.1,
        "description": "Line spacing as a multiplier of em-square (CSS `line-height` model).\n`1.0` = one em of vertical advance per line (tight); `1.2` is the\ntypical default for body text; `1.5` is comfortably spaced.\n\nNote: this is em-relative, not relative to the font's intrinsic\n`common.lineHeight` — that internal metric varies by ~10–30%\nacross fonts, which would make `lineHeight: 1.0` produce\ndifferent visual spacing for the same authored value across\nfamilies."
      },
      {
        "key": "letterSpacing",
        "type": "number",
        "label": "Letter Spacing",
        "default": 0,
        "step": 0.01,
        "description": "Letter spacing in em units (fraction of `fontSize` em-square).\n`0` is the font's default tracking, `0.05` is subtle wide-tracking,\nnegative values tighten."
      },
      {
        "key": "wrap",
        "type": "boolean",
        "label": "Wrap",
        "default": true,
        "description": "Whether a layout-resolved width wraps this paragraph (see \"Wrapping &\nsizing\" above). The width comes from a container's solve, or — with no\ncontainer above the node — from its own `LayoutItem`'s Fixed width\n(tv#709) or a Hug `maxWidth` ceiling: \"text bounds\" is a LayoutItem\neither way, and there is deliberately no authored `maxWidth` on Text.\nDisable for single-line UI text (buttons, badges) that should overflow\nits slot rather than break."
      },
      {
        "key": "bakedWrapWidth",
        "type": "number",
        "label": "Baked Wrap Width",
        "hidden": true,
        "description": "Exported wrap constraint in metres, before node/ancestor transforms.\nOutput only: authoring uses Layout/LayoutItem and replaces this on save.\nContract: https://github.com/TraceXR/trace-viewer/issues/1021",
        "optional": true
      }
    ]
  },
  {
    "type": "Timeline",
    "description": "Controls a unified scene timeline that coordinates playable behaviors.\n\nDrives every Playable (Animation, AudioClip, Video, …) on this object and\nits descendants at any depth. Optionally follows a media master clock\n(`clock`), and applies `active` state cues from `keyframes`. Keyframe\nanimations the timeline starts (play, seek, loop) are sampled at its time\nevery frame — they follow it and its master clock exactly, and advance at\ntimeline `speed` × their own — until something else plays them; media run\non their own clock and are re-seeked on play, seek, loop and snap.\n\nRuntime control: use the `play` / `pause` / `seek` actions (via `call_action`)\nto control playback. Editing `playOnStart` only affects the next load and does\nNOT pause a running timeline.",
    "fields": [
      {
        "key": "duration",
        "type": "number",
        "label": "Duration",
        "default": 10,
        "step": 0.1,
        "min": 0,
        "description": "Total duration in seconds"
      },
      {
        "key": "loop",
        "type": "boolean",
        "label": "Loop",
        "default": false,
        "description": "Whether to loop playback"
      },
      {
        "key": "speed",
        "type": "number",
        "label": "Speed",
        "default": 1,
        "step": 0.1,
        "min": 0,
        "description": "Playback speed multiplier"
      },
      {
        "key": "playOnStart",
        "type": "boolean",
        "label": "Play On Start",
        "default": true,
        "description": "Whether to auto-play when entering play mode"
      },
      {
        "key": "clock",
        "type": "string",
        "label": "Clock",
        "description": "Master clock: path (relative to this object) to a node carrying a\nclock-capable Playable — AudioClip or Video. While playing at\n`speed` 1, the timeline follows that medium's clock: it snaps to it\nwhen more than 0.25 s apart and otherwise slews toward it (so coarse\nmedia time does not jitter), and advances on scene time whenever the\nmedium is not producing time (not loaded, buffering, before its\n`startAt`). The medium is seeked with every other Playable on play,\nseek and loop, but never re-seeked during play; when the timeline\nsnaps, the OTHER Playables are re-seeked to follow it. Ignored when\n`speed` ≠ 1 (media play at their own rate). Unset: scene time only.",
        "optional": true
      }
    ],
    "actions": [
      {
        "name": "play",
        "label": "Start or resume playback"
      },
      {
        "name": "pause",
        "label": "Pause playback (retains current time)"
      },
      {
        "name": "seek",
        "label": "Seek to a time in seconds. Args: (time, mode?) where mode is \"absolute\" (default) or \"relative\" — \"relative\" adds the delta to the current time, so seek(2, \"relative\") jumps 2s forward and seek(-2, \"relative\") jumps 2s back."
      }
    ]
  },
  {
    "type": "Video",
    "description": "Controls video playback settings",
    "fields": [
      {
        "key": "playOnStart",
        "type": "boolean",
        "label": "Play On Start",
        "default": true,
        "description": "Whether to automatically play video on scene start"
      },
      {
        "key": "userInteractible",
        "type": "boolean",
        "label": "User Interactible",
        "default": false,
        "description": "Whether user can interact with video controls"
      },
      {
        "key": "controls",
        "type": "boolean",
        "label": "Controls",
        "default": false,
        "description": "Shows playback controls (i.e. timeline)\nAlso enables userInteractible (tap to play)"
      },
      {
        "key": "loop",
        "type": "boolean",
        "label": "Loop",
        "default": true,
        "description": "Whether to loop video playback"
      },
      {
        "key": "aspect",
        "type": "number",
        "label": "Aspect",
        "step": 0.01,
        "description": "Video aspect ratio (width/height).",
        "optional": true
      },
      {
        "key": "orientation",
        "type": "enum",
        "label": "Orientation",
        "options": [
          "Horizontal",
          "Vertical"
        ],
        "default": "Vertical",
        "description": "Video orientation"
      },
      {
        "key": "fit",
        "type": "enum",
        "label": "Fit",
        "options": [
          "contain",
          "cover"
        ],
        "default": "contain",
        "description": "How the video meets a box whose aspect differs from its own.\n\n`contain` (the default) letterboxes: the plane shrinks on one axis so\nthe whole frame stays visible inside the box, never distorted.\n\n`cover` fills: the plane spans the box exactly and a centered window\nof the frame is shown instead, cropping the overflowing axis. The\ncrop is a view, not an edit — switching back to `contain` shows the\nfull frame again.\n\nAbsent means `contain`: exactly the fit scenes have always had."
      },
      {
        "key": "cornerRadius",
        "type": "number",
        "label": "Corner Radius",
        "default": 0,
        "step": 0.001,
        "min": 0,
        "description": "Corner radius in meters (the unit MeshBackground's cornerRadius\nuses; measured here on the CURRENT visible media rectangle - a\nmedia quad has no rest box). One value gives differently sized\nframes identical corners, and a resized frame keeps its corner\nsize. Never larger than half the rectangle's current smaller side\n- an oversized value degrades to a pill instead of self-crossing.\n\nRounds the media quad itself, which neither Bevel (its host gate\ntakes only builtin primitives) nor MeshBackground (drives the\nlibrary rigs' authored morphs) can reach. Composes with `fit`: the\ncorners round the letterboxed rectangle under `contain`, the full\nbox under `cover`. Strictly geometry: paint stays on Renderer,\nsizing stays on the transform; clients without a corner-radius\nimplementation render the sharp rectangle - content intact."
      },
      {
        "key": "pill",
        "type": "boolean",
        "label": "Pill",
        "default": false,
        "description": "Round the quad to half its smaller side — a capsule at any size,\nwhich is the one shape an absolute radius cannot name. Overrides\n`cornerRadius` when true. Same vocabulary as Bevel and\nMeshBackground (#759)."
      },
      {
        "key": "back",
        "type": "enum",
        "label": "Back",
        "options": [
          "none",
          "picture",
          "color"
        ],
        "default": "none",
        "description": "What the quad's back shows. `none` culls it: nothing is drawn behind\nthe picture. `picture` renders the media on both faces of the one\nquad - seen from behind it reads mirrored, as a print does through\nits paper (a two-sided quad; glTF's doubleSided idea, NOT a second\nreadable surface). `color` backs the picture with a flat unlit\n`backColor` card that also shows through transparent pixels from the\nfront. A GLB export carries what the object shows: `picture` as the\ndoubled quad, `color` as a second mesh named `<quad>_back`."
      },
      {
        "key": "backColor",
        "type": "color",
        "label": "Back Color",
        "default": "#FFFFFF",
        "description": "The card color behind the picture when `back` is `color`\n(#RRGGBB or #RRGGBBAA - the alpha rides the string). Ignored for\nthe other values."
      }
    ],
    "actions": [
      {
        "name": "play",
        "label": "Play the video"
      },
      {
        "name": "pause",
        "label": "Pause the video"
      },
      {
        "name": "stop",
        "label": "Stop playback and reset to the beginning"
      },
      {
        "name": "seek",
        "label": "Seek to a time in seconds. Args: (time, mode?) where mode is \"absolute\" (default) or \"relative\" — \"relative\" adds the delta to the current time, so seek(2, \"relative\") jumps 2s forward and seek(-2, \"relative\") jumps 2s back."
      },
      {
        "name": "setVolume",
        "label": "Set video volume, 0-1 (takes volume argument)"
      }
    ]
  },
  {
    "type": "ViewAnchor",
    "description": "Keeps an object anchored at a gaze-frame offset from the user or an\nanchor object",
    "fields": [
      {
        "key": "enabled",
        "type": "boolean",
        "label": "Enabled",
        "default": true,
        "description": "Whether view anchoring is active when play mode starts. When false the\nobject stays put until the behavior graph enables it\n(trace/setBehaviorEnabled). Disabling at runtime stops it where it is;\nre-enabling re-runs `delay`. Every play-mode start resets to this value."
      },
      {
        "key": "target",
        "type": "string",
        "label": "Target",
        "default": "",
        "description": "Optional anchor: a TransformPath to another scene object whose position\nand world +Z define the gaze frame, or empty to anchor to the user (the\nactive camera and its gaze)."
      },
      {
        "key": "forward",
        "type": "number",
        "label": "Forward",
        "default": 1,
        "description": "How far in front the object rests — meters along the gaze frame's\nforward."
      },
      {
        "key": "lateral",
        "type": "number",
        "label": "Lateral",
        "default": 0,
        "description": "Meters to the right of the gaze (negative = left) — side-docked panels.\nThe lateral axis stays horizontal, so gaze tilt never rolls the offset."
      },
      {
        "key": "vertical",
        "type": "number",
        "label": "Vertical",
        "default": 0,
        "description": "World-up offset of the goal in meters (negative = below the eye line)."
      },
      {
        "key": "viewAngle",
        "type": "number",
        "label": "View Angle",
        "default": 20,
        "description": "Angular dead zone in degrees, measured at the anchor between the object\nand its goal — small head turns don't move it, and off-axis goals\n(lateral/vertical offsets) keep their full dead zone. 180 never\nrecenters for drift (walking away still catches up); compose with\nEnable Behavior for a pure one-shot summon."
      },
      {
        "key": "axes",
        "type": "multiSelect",
        "label": "Axes",
        "options": [
          "x",
          "y",
          "z"
        ],
        "description": "World axes the object may move along. Omit for all three. [\"x\",\"z\"]\nkeeps the authored height while recentering left/right and near/far.",
        "optional": true
      },
      {
        "key": "speed",
        "type": "number",
        "label": "Speed",
        "default": 1.5,
        "description": "Maximum movement speed in meters per second."
      },
      {
        "key": "damping",
        "type": "number",
        "label": "Damping",
        "default": 0.25,
        "description": "Movement smoothing as a time constant in seconds — larger trails more\nsoftly (arrival eases in). 0 moves linearly at full speed."
      },
      {
        "key": "delay",
        "type": "number",
        "label": "Delay",
        "default": 0,
        "description": "Seconds the trigger condition must hold before the object starts\nmoving — the natural \"notice, then recenter\" feel."
      }
    ]
  }
];
